module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace5#toc5"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace5#toc5"
    }
  }, [_vm._v("Nature and Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "CE"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The creature is darkness insofar as it comes out of nothing. But in as much as it has its origin from God, it participates in his image; and this leads to likeness to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("St. Thomas Aquinas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De veritate")]), _vm._v(" q. 18, a. 2, ad 5")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("The words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nature")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grace")]), _vm._v(" have a wide range of meanings, both inside and outside theology. One way to begin to understand that range would be to start simply with etymology. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature")]), _vm._v(" comes from the Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(", itself a noun formed from the Latin deponent intransitive verb "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nascor, nasci, natus sum")]), _vm._v(", meaning “to be born” which gives to English, among a host of other words, terms like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nativity")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nation")]), _vm._v(" (which originally meant the land where one was born), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("innate")]), _vm._v(", meaning “inborn” or “inherent,” which in turn implies the concept of something "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("essential")]), _vm._v(" to the make-up or constitution of a particular entity. What is natural, then, can, in certain contexts, refer to what is essential to something’s identity."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-080-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-080"
    }
  }, [_vm._v("1")])])]), _vm._v(" Thus, expressions like “It’s only human nature” assert (or at least imply) that a particular “natural” behavior or trait is inherent to a human being. Correlatively, when a behavior is described as “unnatural,” the implication is not that such behavior is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("impossible")]), _vm._v(" to perform (like pigs flying, which is certainly unnatural in the absolute sense) but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deplorable")]), _vm._v("."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-079-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-079"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Grace")]), _vm._v(", on the other hand, comes from the Latin noun "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratia")]), _vm._v(", a word with another wide range of semantic content; one Latin dictionary lists these meanings (as determined by the context where they occur): “agreeableness,” “esteem,” “favor” (in the sense of a service done outside of one’s ordinary duties), “indulgence,” and finally, in a very common idiom, “thanks” or “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grati")]), _vm._v("tude.” As with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratia")]), _vm._v(" too is a nominal form derived from a Latin deponent verb, here "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grator, gratari, gratus sum")]), _vm._v(", meaning “to give thanks to” or “to con"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratu")]), _vm._v("late,” from which the adjective "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratus")]), _vm._v(" came to mean “pleasing.” In all of these usages the semantic range stresses what is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" essential, that is, what is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grat")]), _vm._v("uitous, to the entity in question but comes to it as something extra, unexpected, or not required for a nature to be a nature."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-078-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-078"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Thus we speak of someone’s gracious manners, the graceful turn of a ballet dancer, a king’s gracious pardon, or a gracious gesture like holding open a door for someone overloaded with packages. All of which has been usefully summarized by the French theologian Jean Daujat in this way:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The word “grace” is a literal translation of the Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratia")]), _vm._v(", equivalent to the Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("charis")]), _vm._v(" and derived from the Latin adjective "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratus")]), _vm._v(", meaning “pleasing.” Thence is derived the sense of something granted to someone, as being pleasing to him without its being strictly his due, a gratuitous favor granted to an individual without its being an obligation, and finally a “pardon,” a free remission of a penalty incurred. The word also has an important use in aesthetics, so that La Fontaine says it means “something still more than beauty,” and another French writer remarks that the word suggests something that charms us because it expresses or symbolizes something supremely lovable and attractive, such as trust, tenderness, etc. Thus there is a sense in which grace stands for moral qualities. On a last analysis, love is the essence of grace. What we admire in a smile, in gracious manners, in beautiful speech is really the goodness which lies behind them."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-077-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-077"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("This passage begins to hint at the paradox of grace. For if love is the essence of grace, then something peculiar enters the picture here: we all "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("need")]), _vm._v(" love, but love is not love if it has been coerced out of the supposed lover. We all have heard stories of children raised in wealthy homes whose parents give them every material blessing but deprive them of love, thereby warping them (Victorian fiction is filled with such stories). Yet, in a sense, love is not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("due")]), _vm._v(" anyone. What is the value of love if it is not freely given? Thus the paradox: we need love but cannot demand it. Love is love precisely because it is a gift freely—that is, gratuitously—given:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The fundamental meaning of the word “grace” is bound up with love. What pleases us, what we find agreeable, is what we love; but from the first form of love, which is an attraction to the loved object, we pass on to a higher form of love which is a “giving” to the [one] being loved. The lover seeks what is pleasing to the beloved. Real love is always expressed by a giving and, above all, by a giving of one’s self. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The gift that comes from love, all that is generosity prompted by love, such is the deepest meaning of the word “grace.”")]), _vm._v(" From this comes the idea of all that is given without its being the due of the recipient: of all that is purely a gift, of which a pardon, or remission of a punishment, is only one particular and derived sense. So also we have the words “gratuitous,” “gratuity,” “gratuitously.” What is gratuitous is pleasing because it is something given, and it is love that gives. The same meaning is to be found in the expression to be—or not—in someone’s “good graces.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-076-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-076"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Something analogous to that paradox—a requirement than can only be fulfilled by a free gift—can be seen at work in the centuries-long debate on nature and grace in Christian theology. On the one hand, God did not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("have")]), _vm._v(" to create the world, and so in that sense creation is “gratuitous.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-075-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-075"
    }
  }, [_vm._v("6")])])]), _vm._v(" On the other hand, once God creates, he has created "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natures")]), _vm._v(", that is, creatures with their own inherent identity and specific goals, the fulfillment of which is required for them to maintain those natures.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Christian doctrine has consistently maintained what is technically known as God’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aseity")]), _vm._v(", his full self-sufficiency. God is not needy and so did not create the world out of any inherent desperation, the way a lonely child makes a toy and invents a personality to go along with it in order to create an imaginary friend to assuage the pain of isolation. Moreover, Scripture asserts that the act of creation is intimately bound up with Christ’s own incarnation—a gratuitous act on God’s part if ever there was one. For as St. Paul says: “All things were created through him [Christ] and for him” (Col. 1:16b). That word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("for")]), _vm._v(" especially indicates the ultimate purpose of creation: to be united with Christ when all of creation will dwell in God, “who put everything under Christ; [and] when he has done this, then the Son himself will be made subject to him who put everything under him, so that God may be all in all” (1 Cor. 15:27c–28). For Christian revelation, nothing is obviously more gratuitous than the incarnation; but creation itself, as Paul teaches, was created through and for Christ so that all natures will be suffused with the divine presence.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In this perspective, nature becomes not just an analogue, a symbol, or an indicator of grace, a mere "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pointer")]), _vm._v(" to grace, but a true exemplification and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("instantiation")]), _vm._v(" of grace: For the entire universe has been gratuitously created "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in")]), _vm._v(" Christ and is destined for union at the end with that same Christ through whom and for whom creation was aboriginally made, and separation from whom would thus seem to entail a violation of one’s very created nature. In this way, God’s aseity confirms the gracious character of creation, as Daujat rightly stresses:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("It remains to see why God created, seeing that he is perfectly self-sufficing in his infinite perfection to which nothing is wanting. He is in no way obliged to create, for creation adds nothing to him who needs nothing. God, who is infinite freedom, is absolutely free to create or not to create. Hence creation, which brings nothing to him, is on his part purely gratuitous, pure generosity, a pure gift to the creature of everything that it has within it. Being, good, perfection, and therefore creation is a pure act of love, purely the overflow or superabundance of love. God creates in order to give, because he is infinite generosity and love."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-074-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-074"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Despite the obvious truth of this passage, and despite even more the christological hymns in Colossians, one line from which was cited above, the truth expressed by them must be paired with others that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("contrast")]), _vm._v(" grace over against nature. For insoluble problems arise when the grace of creation is seen as seamlessly segueing into the grace of redemption. Indeed, other passages from Scripture stress how completely unmerited and unexpected grace is when it encounters the unsuspecting sinner, who is by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nature")]), _vm._v(" a child of wrath (the added italics stress this special gratuity):")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("As for you, you were dead in your transgressions and sins, in which you used to live when you followed in the ways of this world and of the ruler of the kingdom of the air, the spirit who is now at work in those who are disobedient. All of us also lived among them at one time in the passions of our flesh, gratifying the cravings of flesh and senses, and we were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by nature")]), _vm._v(" children of wrath, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("like everyone else")]), _vm._v(". But God who is rich in mercy, out of his great love for us, made us alive in Christ even when we were dead in our transgressions—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it is by grace that you have been saved")]), _vm._v("—and raised us up with him and seated us with him in the heavenly places in Christ Jesus, so that in the ages to come he might show the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("immeasurable")]), _vm._v(" riches of his grace in kindness toward us in Christ Jesus. For by grace you have been saved through faith, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this is not of your doing; it is the gift of God")]), _vm._v("—not the result of works, so that no one may boast. (Eph. 2:1–9)")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("To be sure, Paul adds in the very next verse a further balance, where he says: “For we are what he has "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("made")]), _vm._v(" us, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("created")]), _vm._v(" in Christ Jesus for good works, which God prepared beforehand to be our way of life” (v. 10). So the paradox remains even from verse to verse in various biblical passages. Of course, Paul is speaking here (mostly) of the operations of grace after the event of sin, which utterly changes the calculus, as it were, of the nature/grace relation—so much so that the next chapter will be devoted to the contrast between sin and grace.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Still, even when the fact of sin is provisionally “bracketed” for purposes of conceptual analysis, Scripture does not always speak of created nature as merely a subspecies of grace sharing the same ontological identity with the grace of redemption. Nature "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("as such")]), _vm._v(", in other words, is seen as the contrasting reality to “pure” grace. Thus in Romans the Apostle will say (again, with italics given to stress the contrast): “For I am sure that neither death, nor life, nor angels, nor principalities, nor things present, nor things to come, nor powers, nor height, nor depth, nor anything else"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" in all creation")]), _vm._v(", will be able to separate us from the love of God in Christ Jesus our Lord” (Rom. 8:38–39). That this contrast holds true even for nature before the fall of Adam Paul makes clear here:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("What is sown is perishable, what is raised is imperishable. It is sown in dishonor, it is raised in glory. It is sown in weakness, it is raised in power. It is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sown a physical body")]), _vm._v(", it is raised a spiritual body. Thus it is written, “The first Adam became a living being” [Gen. 2:7]; the last Adam became a life-giving spirit. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("But it is not the spiritual which is first but the physical, and then the spiritual")]), _vm._v(". The first man was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("from the earth, a man of dust")]), _vm._v("; the second man is from heaven. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("As with the man of dust, so are those who are of the dust")]), _vm._v("; and as is the man of heaven, so are those who are of heaven. Just as we"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" have ")]), _vm._v("borne the image of the man of dust, we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shall")]), _vm._v(" also bear the image of the man of heaven. I tell you this, brethren: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("flesh and blood cannot inherit the kingdom of God, nor does the perishable inherit the imperishable")]), _vm._v(". (1 Cor. 15:42–50)"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-073-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-073"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Traditionally, the two prongs of this paradox—nature considered in itself as a true subspecies of grace, and grace considered as radically disjunctive from nature—come with a terminology: those who stress the continuity between nature and grace are called “intrinsicists,” while those who stress the disjunction between the two are known as “extrinsicists.” However traditional these terms have become, they can be misleading. No alleged extrinsicist really thinks creation has no relationship to Christ, just as no one who has been attacked as an intrinsicist thinks God took no free initiative to save the human race after the event of sin, still less that God “owes” us salvation, no matter how much we might crave rescue from the human plight, and no matter how restless the human heart is without God."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-072-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-072"
    }
  }, [_vm._v("9")])])]), _vm._v(" All supposed extrinsicists agree with St. Augustine that no one is more intimately interior to the soul than God; and no alleged intrinsicist so stresses the total interiority of God to the soul as to become a gnostic, the kind of person who, in Emily Bronte’s poem, could make this kind of prayer:")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("And am I wrong to worship where")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Faith cannot doubt, nor hope despair,")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Since my own soul can grant my prayer?")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Speak, God of Visions, plead for me:")]), _vm._v(" "), _c('p', {
    staticClass: "PL"
  }, [_vm._v("And tell why I have chosen thee.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Nonetheless, shopworn and misleading though these terms can be when addressing and describing what various theologians have actually thought about this issue, the polarity represented by them can serve as useful markers for outlining the various legitimate options "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("within ")]), _vm._v("these extremes. On the one hand, no one wants to make grace so irrelevant to the most fundamental longings of the human heart that God’s offer of salvation can easily be shrugged off and which some happen to accept the way others take up a hobby like building model trains. On the other hand, grace cannot meet us as something "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("expected")]), _vm._v(", as something long overdue. Some authors explain their concerns using the analogy of Old Testament to New: throughout the Old Testament the prophets had promised a Messiah who would liberate the Jews from oppression; but this liberation, when it came, arrived in a way whose acceptance required an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("overthrow")]), _vm._v(" of those very expectations that the Bible had inculcated.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Another way of possibly resolving this issue would be to look at an expression drawn from ordinary language: “There but for the grace of God go I.” This remark can of course be meant in the literal, religious sense but is often said merely to express relief at having made a narrow, unexpected and unforeseen escape. But that idiom also points out how nature’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("variations")]), _vm._v("—in outcome, gradations, talents, and the like—can serve as an analogue to grace strictly defined. Even the most consistent extrinsicists admit that nature often serves as a parable of grace, despite their insistence that nature and grace must not be conflated. This parabolic indicator of grace in nature has been expressed with admirable clarity by the nineteenth-century theologian Daniele Palmieri:")]), _vm._v(" "), _c('p', {
    staticClass: "LN-FIRST"
  }, [_vm._v("\t1.\tEvery act of conceding that something is “necessary” in nature belongs to an infinite hierarchy of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gradations")]), _vm._v(", of which each one can seem like a “grace” to other narrower [lower] gradations.")]), _vm._v(" "), _c('p', {
    staticClass: "LN"
  }, [_vm._v("\t2.\tThe "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de facto")]), _vm._v(" immense "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wealth")]), _vm._v(" of creation, for example, of the animals and plants ordered to man, has a specific “graced” character as such.")]), _vm._v(" "), _c('p', {
    staticClass: "LN"
  }, [_vm._v("\t3.\tMuch that corresponds to human nature in general is not meant for each individual, for example, bodily and mental integrity, prosperity, and so on, especially since certain natural laws exclude the possibility that each isolated individual can partake of all these goods. They are thus, for the individual, “grace” in a preeminent way.")]), _vm._v(" "), _c('p', {
    staticClass: "LN"
  }, [_vm._v("\t4.\tGod could have ordered the world in many other different ways: that he chose "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" total arrangement that furnishes so much beneficence to the individual as well as to the whole can certainly be characterized as a “grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "LN-LAST"
  }, [_vm._v("\t5.\tFinally, the whole environment, necessarily ordered to an innate dynamic as such, is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de facto")]), _vm._v(" and constantly contingent and so has a “gracious” character to it in all its details."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-071-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-071"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Thus we can come to our first conclusion: no so-called extrinsicist thinks grace is so utterly disconnected from nature that it makes no difference to one’s eternal fate how one relates to God’s offer of grace; and no alleged intrinsicist has ever collapsed the distinction between God and the creature as to be, in effect, a pantheist or a gnostic. In that regard, all Christian theologians without exception agree with this fundamental anthropological starting point, so aptly and concisely expressed by Hans Urs von Balthasar (1905–88):")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Thus, though man is created in the image and likeness of God, he is formed from the dust of the earth. Though he is called to be the highest, the nearest to God, he is by origin the lowliest. What lies behind him—the dust of his origin—is a constant reminder that he must not confuse the archetype with the image; the fact that he is an image is a constant reminder that he must conform himself to the archetype on which he is patterned. In other words, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("man’s first state is to be at a twofold remove")]), _vm._v("—at a remove from God and from nothingness. Because he comes from nothing, he retains, however great his likeness to the archetype, an even greater and ineradicable unlikeness. Nor can he increase his likeness to God by becoming more and more unmindful of his origin in order thereby to be more like God. On the contrary, it is only in the measure of his striving to be in the image and likeness of God, even though always at a remove from God, that man fulfills the purpose for which he was created. He achieves the highest measure of this likeness when he has the humility neither to forget nor to deny for an instant his condition of not-being God, the nothingness of his origin."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-070-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-070"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In other words, the very concept of grace "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("requires")]), _vm._v(" that it be set against what is not-grace, that is, against nature. For grace is, ultimately, as we saw above, a relationship established in love; but no love can exist unless the lovers remain distinct from one another:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Any effort to establish an identity of archetype with image would bring about man’s immediate destruction. For it was only because he was at a remove from God that the grace that called him into being could also bestow upon him the grace of likeness. It is only because he is not-God, because he comes to meet God as the unalterably not-God, that he shares in the independence, unity, personality and freedom of his Creator. If a mirror were to be so like what it mirrored that it had become identical with it, what was mirrored would cease to exist. If the two lovers were to attempt so to possess one another that the two were fused into one, then love—if such a thing were possible—would fall into nothingness. To understand any movement of love at all, the lover must proceed from the sure state of his own existence."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-069-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-069"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("So deeply is this reality of not-being-God inscribed in man’s essence—that is, in his nature—that this dilemma has become part of Western literature’s common coinage, for which this famous passage from Alexander Pope’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Essay on Man")]), _vm._v(" (Epistle II.1) may serve as the most rhetorically effective example:")]), _vm._v(" "), _c('p', {
    staticClass: "PF"
  }, [_vm._v("Know then thyself, presume not God to scan;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("The proper study of mankind is man.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Placed on this isthmus of a middle state,")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("A being darkly wise and rudely great:")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("With too much knowledge for the sceptic side,")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("With too much weakness for the stoic’s pride,")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("He hangs between, in doubt to act or rest;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("In doubt to deem himself a god or beast;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("In doubt his mind or body to prefer;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Born but to die, and reasoning but to err.")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Alike in ignorance, his reason such,")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Whether he thinks too little or too much:")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Chaos of thought and passion all confused;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Still by himself abused or disabused;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Created half to rise and half to fall;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Great lord of all things, yet a prey to all;")]), _vm._v(" "), _c('p', {
    staticClass: "PM"
  }, [_vm._v("Sole judge of truth, in endless error hurled:")]), _vm._v(" "), _c('p', {
    staticClass: "PL"
  }, [_vm._v("The glory, jest, and riddle of the world!"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-068-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-068"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("These, then, are the confines of the debate from which theologians rarely stray—and when they do, incoherence quickly sets in. But even though nearly everyone admits that the God-creature distinction remains in force even in the most intimate union with God, the history of theology shows that different emphases become possible, from which then different schools of thought arise. So while no one confesses to being an admitted extrinsicist or intrinsicist (nor, correlatively, is the accusation ever justified when it is leveled by one side against the other), still it is possible to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("veer")]), _vm._v(" toward one extreme or the other. Thus, some theologians will stress the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("continuity")]), _vm._v(" between nature and grace by emphasizing the gratuity of creation coupled with the single will of God that the whole human race be saved; while others will stress the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("discontinuity")]), _vm._v(" between man’s lost state and the quite unexpected divine initiative to save (at least part of) the human race.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("While both sides of this debate operate within orthodox boundaries, as we have seen, the dispute between them is not minor; for a lot rides on it, above all God’s ultimate intentions in creating and saving the world, as was already pointed out in the Introduction. The trouble is, Christians (including theologians) often take a position on those wider, more burning issues first and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("then")]), _vm._v(" cobble together a theology of the nature/grace relation to justify—or at least shore up—an already adopted position. Such a procedure is not, in and of itself, problematic. For there is nothing about the theology of grace that says it has to come first, either logically or chronologically; and in the history of theology one often notes a reciprocal interchange between, say, the issue of eschatology and that of grace, with one reinforcing the other and without any evident cause-effect priority of one over the other.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("That said, since this book is a work not on eschatology, nor on the church’s relation to the modern world, nor on the diversity of world religions in light of divine providence, but strictly on grace, the question to be addressed here is this one: is there some way of resolving the debate between continuity and discontinuity in the nature/grace relation when it is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("taken in isolation")]), _vm._v(" from other issues, so that it can then cast retrospective light on all these other topics?")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Perhaps there is, although at first glance the ins and outs of this controversy might seem arcane, one of those debates that generate a lot of heat and dust among theologians but which will probably strike the non-expert as providing little light. If not pointless, the debate often strikes the outsider as at least remote from everyday concerns. But on closer analysis, this seemingly arcane controversy can in fact prove highly illuminating for other issues as well: and this can be seen above all in the question of whether man has, by virtue of his nature as a created being, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" desire for God.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Now, given St. Augustine’s famous line early in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confessions")]), _vm._v(" that our heart is restless until it rests in God, it would seem that tradition holds in the affirmative, that is, that man does indeed have a natural desire for God. But in fact that answer, while perhaps superficially obvious, runs into difficulties. Perhaps for Augustine, the issue admitted of a simple answer, but not for Aquinas. Here, in simplified terms, is how the Augustinian tradition sees it, according to William O’Connor:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("St. Augustine knew as well as Aristotle that man’s will tends by a necessity of its nature towards happiness, the notion of which is imprinted on our minds. He also knew that true happiness or beatitude is found only in God. It is but a step to identify the happiness we are seeking by a necessity of our nature with God, and there does not seem to be any reason to doubt that St. Augustine made this step. Since God is in fact the soul’s beatitude, it is all one with him to say that the soul is borne by its nature towards happiness and to say that it is borne by its nature toward God."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-067-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-067"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T1"
  }, [_vm._v("This insight was so obvious to Augustine that the alternative seems never to have entered his mind; and in fact he explicitly says in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Soliloquies")]), _vm._v(" that every being capable of loving is loving God whether he is aware of it or not."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-066-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-066"
    }
  }, [_vm._v("15")])])]), _vm._v(" Partly, this is an outcome of his Platonic epistemology, whereby man comes to the knowledge of the truth, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _vm._v(" truth, only because of a prior divine illumination enlightening his soul, a view also shared by St. Bonaventure."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-065-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-065"
    }
  }, [_vm._v("16")])])]), _vm._v(" Now obviously, if God must be so directly involved in the attainment of truth, even natural truths, then man must have a natural desire for God correlative to his natural desire for the truth, as O’Connor explains:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("St. Augustine placed, or rather discovered, in the soul of every man, prior to grace "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and prior even to conscious reflection")]), _vm._v(", a natural desire for God as our beatitude. . . . [S]o long as the divine illumination of truth was retained in the Augustinian tradition, a natural desire for God followed upon it as a necessary consequence. We see this in the teaching of St. Bonaventure, a pure Augustinian, for whom the soul has an innate knowledge of the existence of God as its supreme good, since it is made in His image and likeness. This gives rise to a natural desire for God as our beatitude: “The soul naturally tends toward the one in whose image it has been made, in order that in Him it may be beatified.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-064-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-064"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Aquinas, however (and notoriously for his time), denied this special divine illumination and with Aristotle held that natural truths were accessible to the human mind through entirely natural faculties."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-063-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-063"
    }
  }, [_vm._v("18")])])]), _vm._v(" Given Plato’s great prestige among most medieval theologians of that time, and given as well the correlative suspicion with which Aristotle was regarded in the thirteenth century, not to mention the overpowering weight of Augustine’s authority in theological debate (not least in matters of grace), and given the wholesale adoption of the theory of divine illumination by Bonaventure, Thomas Aquinas certainly caused a stir, not least because his epistemology made God much more "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("obscure")]), _vm._v(" and the path to God correlatively that much more arduous."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-062-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-062"
    }
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("It is often forgotten how nugatory are the results of Thomas’s Five Ways—which lead, to be sure, to “what all men call God”; but still, although we can be sure of God’s “factual” existence, we still can know nothing of God’s essence: “Created things are not sufficient to represent the Creator,” says Thomas. “Hence we cannot possibly arrive at perfect knowledge of the Creator from creatures; in addition, because of the weakness of our intellect, we cannot even know all that created things manifest of God.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-061-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-061"
    }
  }, [_vm._v("20")])])]), _vm._v(" And, as O’Connor explains, the effect of that position on the question of man’s natural desire for God is direct and immediate, and indeed revolutionary:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Is it not true that God is our beatitude? Has it not been revealed that the vision of God is the end of man? That is the whole point. It is a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("revealed")]), _vm._v(" truth that the vision of God is the only historical end man has ever had, so that the purely natural man with a purely natural end has never existed. Does this mean that the human will by its very nature has an innate, necessary tendency towards God, or the vision of God, as our beatitude? Does it mean that the intellect is tending by its nature as intellect, prior to all actual knowledge, towards this vision as the only object that can finally put an end to its unlimited craving for truth? In other words, has every intellectual creature a natural desire for the beatific vision? When the question is worded in this fashion St. Thomas’ answer is, I believe, a straightforward no."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-060-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-060"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("What accounts for this strange turn of events? How could Thomas deny what seemed so obvious to Augustine, who said that, since we were aboriginally created for union with God, we must accordingly bear within our natures a trace of that divine intention? How could God’s purposes not be inscribed in our very desires? As we saw above, part of the reason for this shift made by Thomas stems from his denial of divine illumination in the human soul giving access to natural truths. This denial makes God inherently obscure. But Thomas also has another argument: free will. If matters were as Augustine held, then man would gravitate toward God of necessity, the way a hungry teenager gravitates toward the school cafeteria line at lunchtime. But such is obviously not the case: men are constantly rebelling against God. As Pascal asked so pointedly: “If man is not made for God, why is he only happy with God? If man is made for God, why is he so hostile to God?”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-059-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-059"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ergo")]), _vm._v(", man is not created with a natural desire for God, and this despite all previous tradition, as O’Connor explains:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("St. Augustine taught that even in this life the mind sees or makes an identification of God with man’s beatitude, so that the will cannot help being drawn towards Him by natural necessity. For St. Thomas we do not see in this life an identification of God with the good in general or with happiness. For this reason the human will is not drawn by natural necessity towards God or the vision of God as the object that constitutes our beatitude. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The knowledge of God we have in this life is indirect, mediate, abstract, obscure")]), _vm._v(". It does not present God to us as He really is. If an object appeared to us as good from every point of view, the will would of necessity tend towards it and seek its rest in it. This will be the case in the next life when we shall see God as He is, but we do not see Him now. We know from revelation that He is our true beatitude and ultimate end and we should freely adhere to Him, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("even though we cannot do so by natural necessity")]), _vm._v(". The mere fact that we are capable of turning away from God as our ultimate end proves that we have not a determined tendency towards Him as our beatitude as we have towards happiness in general."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-058-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-058"
    }
  }, [_vm._v("23")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T2"
  }, [_vm._v("As is well known (at least among those theologians invested in this debate), the twentieth-century Jesuit theologian Henri de Lubac (1896–1991) took the exact opposite position. In an oft-cited passage, he made this claim:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("It is said that a universe might have existed in which man, though without necessarily excluding any other desire, would have his rational ambitions limited to some lower, purely human, beatitude. Certainly I do not deny it. But having said that, one is obliged to admit—indeed one is automatically affirming—that in our world as it is this is not the case. . . . In me, a real and personal human being, in my concrete nature—that nature I have in common with all real men, to judge by what my faith teaches me, and regardless of what is or is not revealed to me either by reflective analysis or by reasoning—the “desire to see God” cannot be permanently frustrated without an essential suffering. To deny this is to undermine my entire Credo. For is not this, in effect, the definition of the “pain of the damned”? And consequently—at least in appearance—a good and just God could hardly frustrate me, unless I, through my own fault, turn away from him by choice."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-057-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-057"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("But where does that freedom come from, and what does it say about man’s natural desire for God? De Lubac does not say. For as we saw above, O’Connor takes Thomas’s side (or what he takes to be the doctrine of the Common Doctor in this matter) precisely to avoid the implications of necessity entailed in the Augustinian view. And sure enough, no sooner has de Lubac seemed to concede a freedom on the part of a human person to reject his deepest desire, he lapses back into calling this natural desire entirely constitutive of the human person:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The infinite importance of the desire implanted in me by my Creator is what constitutes the infinite importance of the drama of human existence. . . . For this desire is not some “accident” in me. It does not result from some peculiarity, possibly alterable, of my individual being, or from some historical contingency whose effects are more or less transitory. . . . It is in me as a result of my belonging to humanity as it is, that humanity which is, as we say, “called.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("For God’s call is constitutive")]), _vm._v(". My finality, which is expressed by this desire, is inscribed upon my very being as it has been put into this universe by God. And, by God’s will, I now have no other genuine end, no end really assigned to my nature or presented for my free acceptance under any guise, except that of “seeing God.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-056-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-056"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Notice here how de Lubac is arguing backward from eschatology to his assertion that man has an innate, natural desire for God; for the pains of hell are due precisely to the eternal frustration of that desire. Of course, the hypothesis of a limbo for infants who die before baptism would claim the opposite; for here would be a post-mortem realm where natural desires could be fulfilled without an eternal frustration."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-055-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-055"
    }
  }, [_vm._v("26")])])]), _vm._v(" But that hypothesis has largely been abandoned, not least because the Second Vatican Council seems to have undercut it with its assertion of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("single")]), _vm._v(" end for man: “For, since Christ died for all men, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("since the ultimate vocation of man is in fact one, and that divine")]), _vm._v(", we ought to believe that the Holy Spirit, in a manner known only to God, offers to every man the possibility of being associated with this paschal mystery.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-054-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-054"
    }
  }, [_vm._v("27")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("That text, more than any other from that epochal council, explains why de Lubac’s reassertion of Augustine’s view won out during roughly the first forty years after the council. Very few dissenting voices could be heard in that time against de Lubac’s programmatic statement in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Surnaturel")]), _vm._v(" that the “spirit just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" desire for God.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-053-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-053"
    }
  }, [_vm._v("28")])])]), _vm._v(" Given the way the debate was framed in those postconciliar years, such a consensus can hardly come as a surprise, as seen in this memoir by someone who lived through and was trained in that time:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Declaring “pure nature” not to belong to the subject matter of theology was also the remedy against what Maurice Blondel labeled an “extrinsicist” view of grace, or what we as students referred to as “Suárez’s cream cake.” It is the well-known picture of nature and grace as two tiers, one on top of the other, without an intrinsic connection between the two. Human nature is complete in itself, and it might well do without grace, that is, without a personal relation to God. Without the cream of grace, it would be a little dry and less tasty, but the cake of nature is not really affected by the cream topping. However, from a religious, and hence also from a theological perspective, such a view was completely unacceptable. It alienated grace and faith from our personal, concrete, everyday life and from the larger reality of society and the world by promoting a flight into a distinct spiritual realm. It domesticated and isolated theology, confining it to the little, sheltered niche of the supernatural, fully disconnected from the humanities and sciences."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-052-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-052"
    }
  }, [_vm._v("29")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Given recent criticisms leveled against de Lubac, it takes some imagination to see why his argument proved so convincing. Bernard Mulcahy (as it happens, a strong critic of de Lubac’s thesis) summarizes de Lubac’s argument with admirable and sympathetic objectivity here:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Against the notion of pure nature, first, it may be objected that pure nature is not, and has never been, the state of any real human being. . . . Second, one may object that the notion of pure nature is alien to the Christian tradition. . . . In fidelity to tradition, the argument goes, we ought to imitate the early doctors and ignore the idea of pure nature. . . . Third, it has been objected that the idea of pure nature is dualistic. . . . [leaving theology] unable to think of grace except as a sort of alien invader, a foreign organism which seizes our nature and forces us to be its host. In addition, to treat nature and grace as only extrinsically related is to imply that grace leaves our natural, everyday human life untouched, reserving its effects for a separate “religious” part of our humanity. . . . Fourth, and finally, it is said that the idea of pure nature is to blame for certain ills of the modern Church and world. The critics of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura pura")]), _vm._v(" . . . hold that this scholastic concept has contributed to the marginalization of Christianity in the Western world. Alone or in combination with other principles, the idea of pure nature is made to carry the blame for atheistic humanism, capitalism, secularism, and an array of other phenomena which the critics of pure nature find objectionable."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-051-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-051"
    }
  }, [_vm._v("30")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("But recently, new voices have insisted they be heard, claiming that de Lubac went too far. Part of their case is historical. For one of the most controversial aspects of de Lubac’s claim was that Thomas "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("agreed with de Lubac")]), _vm._v(" and that therefore most of the later commentators misunderstood Thomas from the ground up on this issue. While it is of course theoretically possible that the commentators understood Thomas better than he understood himself, and that therefore the commentary tradition represents a legitimate development of the thought of the Common Doctor,"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-050-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-050"
    }
  }, [_vm._v("31")])])]), _vm._v(" most of those who object to de Lubac claim the historical Thomas is on their side.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("So who is right, O’Connor or de Lubac? In retrospect, it has now become clear that there are texts in the Thomist corpus that could be used by either side, a point now becoming increasingly evident in the course of this drawn-out battle. As Steven Long rightly points out:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("It helps to put to rest the exegetic difficulty. It is without doubt true that there is a problem in the very texts of Aquinas, and a problem which seemingly does not allow much room for maneuver with respect to its solution: because the doctrinal points which constitute the elements of the problem—one is almost tempted to say “constitute the contradiction”—are starkly and clearly stated in St. Thomas’s texts. Yet the realization that there are indeed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("two")]), _vm._v(" sets of texts, one of which was not merely an interposed corruption, itself marks a decisive advance toward correct interpretation of Thomas’s teaching. . . . The second set of texts hedges about, and delimits, the possible signification of the first set, and vice versa. That is, on the supposition that we do not wish to suppose St. Thomas’s texts to exhibit raw incoherence, then we need to read these texts in relation one to another."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-049-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-049"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Part of the problem stems from the fact that Thomas never addressed, at least explicitly, the specific question that motivated the twentieth-­century controversy, when the terms of the debate shifted from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("desire")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exigency")]), _vm._v(", a much stronger term suggesting an essential requirement for a nature to function as a nature (like the exigency for food in animals), which God would accordingly be “obliged” to fulfill, which would violate the root meaning of grace. We have already cited Paul’s defense of the gratuity of grace here: “As for you, you were dead in your transgressions and sins. . . . But because of his great love for us, God, who is rich in mercy, made us alive with Christ even when we were dead in transgressions—it is by grace that you were saved” (Eph. 2:1, 4–5).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("But that passage does not really address the question that has been animating so much of the contemporary debate. For, once grace has been given, further questions arise: Are we allowed to feel more than just the appropriate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratitude")]), _vm._v(" for having received this gift that we could never have merited or deserved? That is, does the unmerited gift of grace cast a retrospective light on our past life of sin so that we are also permitted to feel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("relief")]), _vm._v(" that we have been rescued from a plight that we had long recognized prior to receiving grace? Is grace, then, like a trace mineral (zinc, for instance) whose absence from one’s diet led to a kind of vague physiological malaise whose discontents (caused by factors not yet suspected) were never fully appreciated in their outermost extremity until the homeostasis of good health returned with a healthier, more balanced diet, but had nonetheless led to a felt listlessness that went on for years? In other words, does grace heal the soul’s prior malaise in a way that makes grace seem, at least retrospectively, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("like the answer to a spiritual exigency")]), _vm._v(", defined here as a crying need that had all along caused man to ache for grace ever since his expulsion from the Garden of Eden—a longing, moreover, that he had been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("noticing")]), _vm._v(" all along?")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The usual answer in modern theology, starting with the condemnations of Michael Baius (1513–89) and Cornelius Jansenius (1585–1638)—both of whom had answered “Yes” to those questions—has been that man cannot have been given an inherent, innate exigency for grace, under the Aristotelian rubric that natural desires cannot be in vain."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-048-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-048"
    }
  }, [_vm._v("33")])])]), _vm._v(" Applying that Stagirite axiom,"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-047-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-047"
    }
  }, [_vm._v("34")])])]), _vm._v(" theologians argued as follows: if God had implanted an exigency for grace as part of our very nature, he would accordingly “owe” us grace, which would of course destroy its gratuity, making it no longer truly grace but something we could, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horribile dictu")]), _vm._v(", “count on.” Hence, by an ineluctable logic, man has no innate, natural desire for God.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("While this denial of a natural spiritual exigency is plausible—even inevitable in the wake of Baius and Jansenius—a problem lurks if that answer becomes too one-sided. For Scripture reveals that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" of creation (and not just the human spirit) does indeed “groan” for its fulfillment in Christ:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("We know that the whole creation has been groaning as in the pains of childbirth right up to the present time. Not only so, but we ourselves, who have the firstfruits of the Spirit, groan inwardly as we wait eagerly for our adoption as sons, the redemption of our bodies. For in this hope we were saved. But hope that is seen is no longer hope at all. Who hopes for what he already has? But if we hope for what we do not yet have, we wait for it patiently. (Rom. 8:22–25)")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("What makes this passage so fascinating is the way Paul easily ascribes a natural longing to all creation (which can hardly be said to have “sinned”); yet he goes on to assert a further longing for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something not our due")]), _vm._v(". Crucially, as he points out, human longing is one for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("adoption")]), _vm._v(". Now adoption refers to a legal status to which obviously a person has no claim: even a bedraggled, desperately hungry, rag-clad waif cannot go to a court of law and demand to be taken in by any family of his arbitrary choosing. Certain rights accrue naturally to natural-born children; adoption, however, is a freely bestowed legal status by which the one being adopted is (as we say) “graciously” allowed to belong legally to a particular family. My hapless parents were stuck with me and my dreadful infantile caterwauling upon my entrance into the world; but I have no claim to the estate of Bill Gates. (The novels of Charles Dickens, especially "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Copperfield")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Expectations")]), _vm._v(", often hinge on this universally recognized reality.)"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-046-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-046"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Although, as said above, Thomas did not directly address this particular question as phrased this way, his extraordinarily subtle discussion of the nature/grace relation did have an enormous influence in later debate—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and for both sides")]), _vm._v(". On the first side of the ledger, we have St. Thomas’s argument that to know God is the end of every intelligent substance:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Since all creatures, even those devoid of understanding, are ordered to God as to an ultimate end, all achieve this end to the extent that they participate somewhat in His likeness. Intellectual creatures attain it in a more special way, that is, through their proper operation of understanding Him. Hence, this must be the end of the intellectual creature, to understand God. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summa contra Gentiles")]), _vm._v(" III, 25.1)")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("From this consideration, Thomas directly concludes in this same chapter that man’s desire for God is entirely natural: “There is naturally present in all men the desire to know the causes of whatever things are observed. . . . Therefore, man naturally desires, as his ultimate end, to know the first cause. But the first cause of all things is God. Therefore, the ultimate end of man is to know God” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summa contra Gentiles")]), _vm._v(" III, "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("25.")]), _vm._v("11). Furthermore, for Thomas, following Aristotle here, no natural desire may be in vain ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I, q. 75, a. 6; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Compendium theologiae")]), _vm._v(" 104). Finally, there is this stark, quasi-Augustinian statement:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Final and perfect happiness can consist in nothing else than the vision of the divine essence. . . . If therefore the human intellect, knowing the essence of some created effect, knows no more of God than that he is, the perfection of that intellect does not yet reach simply the First Cause, but there remains in it the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" desire to seek the cause. Wherefore it is not perfectly happy. Consequently, for perfect happiness the intellect needs to reach the very essence of the First Cause. And then it will have its perfection through union with God as with that object in which "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alone")]), _vm._v(" man’s happiness consists. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I-II, q. 3, a. 8; emphasis added)")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In some passages, Thomas even compares man’s natural desire for God with biological instincts, as Howard Kainz rightly points out."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-045-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-045"
    }
  }, [_vm._v("36")])])]), _vm._v(" According to Kainz, Thomas means this term to be taken quite literally: the faith-­instinct is univocally parallel to the instincts for self-preservation, sexual congress and hunger for knowledge, differing only in the object of the instinct’s exigent craving. Although in this passage Thomas uses the milder term “inclination,” he does so in the context of speaking of those drives that later biologists will call “instincts,” especially that of self-preservation:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("In man there is first of all an inclination ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("inclinatio")]), _vm._v("] to good in accordance with the nature he has in common with all substances—inasmuch as every substance seeks the preservation of its own being, according to its nature; and by reason of this inclination, whatever is a means of preserving human life and of warding off its obstacles belongs to the natural law. Secondly, there is in man an inclination to things that pertain to him more specifically, according to that nature which he has in common with the other animals; and in virtue of this inclination those things are said to belong to the natural law which nature has taught to all animals, such as sexual intercourse, education of offspring and so forth. Thirdly, there is in man an inclination to good according to the nature of his reason, which nature is proper to him; thus man has a natural inclination to know the truth about God. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I-II, q. 94, a. 2)")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T1"
  }, [_vm._v("Although "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("inclinatio")]), _vm._v(" is the word of choice here, Thomas uses the stronger word “instinct” in other passages to explain not biological drives but, fascinatingly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the universality of natural religion")]), _vm._v(". Religion is an anthropological constant, says the Common Doctor, because man has an instinctive drive to worship God: “under the state of the law of nature, man was moved, by inward instinct alone ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("solo interiori instinctu")]), _vm._v("] and without any outward law, to worship God; [furthermore] the sensible things to be employed in the worship of God were also determined by inward instinct ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ita etiam ex interiori instinctu")]), _vm._v("]” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" III, q. 60, a. 5, ad 3). Elsewhere Thomas says: “man feels that he is obligated ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("obligatum")]), _vm._v("] by some sort of natural instinct ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quodam naturali instinctu")]), _vm._v("] to pay reverence to God in his own way, from whom comes the beginning of man’s being and of all good” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ScG")]), _vm._v(" III, c. 119)."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-044-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-044"
    }
  }, [_vm._v("37")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("So, relying on these passages, does Thomas hold, as de Lubac claimed, that each human being has an innate natural desire for God, an exigency for the beatific vision? There is, after all, no biological drive without a corresponding exigency, no instinct without an object to crave (including the drive to know, as per the scholastic axiom: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("intellectus caret omnibus illis quas natus est intelligere")]), _vm._v(": “the intellect craves all those things it is born to know”). Given Thomas’s terminology here, the obvious answer seems to be Yes: if we have a natural instinct to revere the God of our origins, then we must desire union with God by that same natural instinct.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("But that affirmative answer can only prove convincing if we also airbrush away another set of texts that argue the contrary. For elsewhere Thomas could not be clearer that man has a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("twofold")]), _vm._v(" end, one inherent in his nature as a created, embodied intellect, and the other, an added, supernatural one bestowed on him gratuitously, one given to him in order to lead him to desire supernatural union with God. This position is especially clear in a passage that seems directly to contradict the passage cited immediately above (not to mention the teaching of Vatican II in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gaudium et Spes")]), _vm._v(" §22, also cited above):")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Man is perfected by virtue, [which enables him to perform] those actions whereby he is directed to happiness. . . . Now man’s beatitude or happiness is twofold ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Est autem duplex hominis beatitudo sive felicitas")]), _vm._v("]. . . . One is proportional to human nature, a happiness, that is, which man can obtain by means of his natural principles. The other is a happiness surpassing man’s nature, and which man can obtain by the power of God alone, by a kind of participation of the Godhead. . . . And because such happiness surpasses the capacity of human nature, man’s natural principles, which enable him to act well according to his capacity, do not suffice to direct man to this same [supernatural] happiness. Hence it is necessary for man to receive from God some additional principles, whereby he may be directed to supernatural happiness, even as he is directed to his connatural end by means of his natural principles, albeit not without divine assistance. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I/II, q. 62, a. 1)"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-043-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-043"
    }
  }, [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In an earlier work, Thomas makes virtually the same point but in even starker terms: “The final good of man is twofold. One is in proportion to human nature, the other is a good that exceeds this proportion, since the forces of nature are not sufficient to obtain it, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("or even to think about it or desire it")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nec ad cogitandum vel desiderandum")]), _vm._v("]. This is eternal life, which is promised to man solely by divine generosity” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De veritate")]), _vm._v(" q. 14, a. 2; emphasis added)."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-042-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-042"
    }
  }, [_vm._v("39")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Among historians of theology, an almost universal consensus holds that the vast majority of Thomist commentators stress—and develop—this side of Thomas’s teachings on the natural desire to see God, the side that insists on the twofold ends of man, as Lawrence Feingold has shown in massive detail in a highly regarded study."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-041-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-041"
    }
  }, [_vm._v("40")])])]), _vm._v(" Out of that development came the introduction of two technical terms that have themselves become heated topics of debate: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elicited desire")]), _vm._v(" (as opposed to natural), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("obediential potency")]), _vm._v(". The first refers to a desire to know God as First Cause born out of philosophical wonder; the second to God’s ability to create a new nature as the basis for the gift of supernatural grace strictly defined.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As to the first term, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elicited desire")]), _vm._v(", Feingold admits that “texts of St. Thomas concerning the natural desire to see God do not directly address or explicitly determine the question of whether the natural desire in question is elicited or innate, which explains the divergence of views which have existed and which still exist in this matter.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-040-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-040"
    }
  }, [_vm._v("41")])])]), _vm._v(" But the distinction was made because it seemed to solve the problem of God creating a nature with an innate desire that he would then “have” to fulfill. Moreover, elicited desire can account for why so many are not moved to worship God, who alone can fulfill all our desires, of whatever species, as Feingold explains here:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The object, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("once considered")]), _vm._v(", naturally attracts the will and thus specifies its act to be one of desire or love and not indifference. This means that objects of natural willing are not always being willed in act, but only when the object is considered. This distinction is important with regard to the natural desire to see God. In order for this to be a natural desire, it is not necessary for rational creatures to always actually desire it, but only when the mystery of God is considered. It may be that a thoughtless or worldly person, or an atheist, never considers this, and therefore never actually desires it."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-039-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-039"
    }
  }, [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Corresponding to the distinction between natural and elicited desires is the correlative distinction between natural and obediential potency. Once again, the distinction was made to avoid tying nature too closely to grace, which would entail what the scholastics called a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("debitum naturae")]), _vm._v(", meaning a nature to which God “owed” grace. A purely “natural” potency means a potential that its nature is bound to actualize, whereas an “obediential” refers to a potency that is fulfilled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only when a new nature takes the place of the old one")]), _vm._v(", as when John the Baptist said that “God can raise up out of these stones children of Abraham” (Matt. 3:9). But for de Lubac of course, that is just the problem: now actual nature has become so divorced from a supposedly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("miraculous")]), _vm._v(" nature that secular man can shrug off the announcement of the good news of salvation as irrelevant to his concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("However, that was not quite the point that the Thomist commentators were making. St. Paul does, after all, speak of us becoming a new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("creation")]), _vm._v(": “Therefore, if anyone is in Christ, he is a new creation; the old has gone, the new has come” (2 Cor. 5:17). Now clearly Paul is not referring here to pagan stones having been transformed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("first")]), _vm._v(" into different "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kinds")]), _vm._v(" of souls now capable of hearing the gospel, upon which sits atop the grace of redemption. And so a further distinction was made between a “generic” obediential potency based on God’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("potentia absoluta")]), _vm._v(" to do anything not inherently self-contradictory (like his ability to create children of Abraham out of stones), and a “specific” obediential potency, based on God’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("potentia ordinata")]), _vm._v(", by which he operates using the natural materials he has already created. Thus, humans, as a spiritual and intellectual species, do have a capacity for the beatific vision; it’s just that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("human nature cannot actualize this potential on its own: for not only must the potential be given as a grace (but here as part of the grace of creation), so too, and preeminently, must the actualization")]), _vm._v("; and that is what is meant by “obediential” potency.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T2"
  }, [_vm._v("Now as anyone with even a passing acquaintance with scholastic philosophy and theology knows, scholastic thinkers are fond of distinctions, overly so to their critics. (Renaissance writers like Erasmus and Petrarch were particularly scathing in that regard.) But generally speaking, these distinctions arise because they serve a purpose, they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("function")]), _vm._v("; specifically they bring to light previously unsuspected contradictions and resolve them through a more nuanced treatment of terms. Such, I believe, is the case here. Of course, not every distinction actually serves its purpose; and if de Lubac is right, the utility of terms like “elicited desire” and “obediential potency” has long met (and passed) its sell-by date. But others, like Steven Long, disagree and claim that, absent this distinction, only confusion will result:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Inasmuch as creatures can be said to be in potency to that which only the divine power can bring forth in them, it nonetheless remains true that God can bring about certain effects only in certain natures. For example: only a knowing and loving creature can, through the active agency of God, be brought to graced knowledge and love of God. If God can raise up sons of Abraham from the very rocks, this can only be by rendering them no longer to be rocks. By contrast, the life of grace "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("through the active agency of God")]), _vm._v(" perfects human persons, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("uplifting")]), _vm._v(" human nature without destroying or mutating it."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-038-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-038"
    }
  }, [_vm._v("43")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Here perhaps is the most crucial issue in this debate: how much agency should be attributed to God and how much to the human person? (This issue, as it happens, dominates the entire theology of grace, as the rest of the chapters of this book will show.) For de Lubac, since man as spirit just "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" the desire for God, the human person will always be actively seeking God, whether he realizes it or not, and whether or not the individual puts God at the center of his life. But Long denies this, precisely to preserve the gratuity of grace:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("A rock cannot know and love God without ceasing to be a rock—it cannot even be “helped” to know and love because it lacks any such faculties that might be so helped. By contrast, while a human person cannot know and love God in direct vision and embrace him without supernatural aid, with such aid the human person may partake in intrinsically supernatural divine friendship: and this is the specific notion of obediential potency as applied to the relation of grace to nature. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It is a wholly passive potency")]), _vm._v(" that yet presupposes as its subject some determinate nature that is such that when aided by the active agency of God it may achieve a certain specific range of actuation. It is because of man’s essentially spiritual nature that he has an obediential potency to the spiritual life."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-037-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-037"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Because this issue of agency touches so directly on the question of predestination and free will, a full discussion of agency, divine and human, will have to be postponed until the chapter specifically devoted to that topic. (It obviously also affects the whole question of “merit,” treated in the next chapter.) Suffice it to say here that the distinctions between natural and elicited desires and between natural and obediential potency, arcane though they might seem at first glance, carry vast implications for other issues, which is perhaps another way of saying that these distinctions perform a function and cannot be dismissed as mere scholastic hairsplitting.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Whatever be the outcome of that debate, there can, however, be no doubt that these terms cannot be found in so many words in Thomas, as Feingold himself concedes, as we saw above, although many of his texts do lead to a legitimate development of his thinking by his commentators, as we also saw above. Still, the point bears stressing: Thomas does not treat the matter of God’s debt to nature ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("debitum naturae")]), _vm._v("), nor does he distinguish natural from elicited desire, or speak of obediential potency, in the same way modern commentators do. Thomas certainly does not react in horror to the idea that God might “owe” us anything, as we see here:")]), _vm._v(" "), _c('p', {
    staticClass: "EX ParaOverride-1"
  }, [_vm._v("In the divine operations debt may be regarded in two ways, as due either to God, or to creatures, and in either way God pays what is due. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It is due to God that there should be fulfilled in creatures what his will and wisdom require")]), _vm._v(", and what manifests his goodness. In this respect God’s justice regards what befits him, inasmuch as he renders to himself what is due to himself. It is also due to a created thing that it should possess what is ordered to it. . . . Thus God also exercises justice when he gives to each thing what is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("due")]), _vm._v(" to it by its "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nature")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("condition")]), _vm._v(". ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I, q. 21, a. 1, ad 3; emphases added)."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-036-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-036"
    }
  }, [_vm._v("45")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("What is fascinating about this passage is that it can be used by either side, for Thomas never addresses the question at hand: does this nature have a burning exigency for God, which puts God under the “obligation” (but only to himself!) to sate that exigency; or is that nature such that God can add a higher desire, a higher nature, a higher calling?"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-035-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-035"
    }
  }, [_vm._v("46")])])]), _vm._v(" Thomas never addressed that question directly, as we can see from the fact that he bequeathed to his disciples two seemingly contrary sets of texts that are left to his later interpreters to harmonize."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-034-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-034"
    }
  }, [_vm._v("47")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Reconciling these two sets of apparently opposing positions has of course not been an easy task, the difficulty of doing which no doubt accounts in large measure for the protracted length and irresolvability of this debate over the centuries. But that is a burden for historical theologians to work out, since their method by definition is to deal strictly with the Thomist texts as they stand. Of more immediate concern in this chapter is the more strictly systematic, conceptual or dogmatic question: can developments in more recent centuries be brought to bear to reconcile these two positions, especially in the light of Vatican II?")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For the debate does seem rather to have reached a stalemate."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-033-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-033"
    }
  }, [_vm._v("48")])])]), _vm._v(" Yet all along, a solution has been at hand, one offered already in the nineteenth century. It will be the thesis in the rest of what follows that the theology of the German Matthias Joseph Scheeben (1835–1888) has given us a viable solution to this problem."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-032-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-032"
    }
  }, [_vm._v("49")])])]), _vm._v(" Although he was highly regarded in the first half of the twentieth century, changes in the postconciliar outlook quickly led to widespread neglect of his writings."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-031-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-031"
    }
  }, [_vm._v("50")])])]), _vm._v(" But, as will become evident in what follows below, the time has come for him to be restored to his rightful place in the contemporary debate, for his theology of the nature/grace relation does in fact offer not just a way out of the dilemma outlined above but also the path to real reconciliation of positions seemingly opposed.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("One reason the influence of a neglected theologian can return is because later generations come to realize that this unfairly ignored theologian has already solved a controverted problem "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("even before the controversy arose")]), _vm._v(". Such, I maintain, is the case with Scheeben on the issue now before us. For what he has managed to do, at least in my estimation, is to concede all the distinctions necessary for keeping grace gratuitous and for delineating nature as a correlative reality independent of grace; but he made all those distinctions for the purpose of showing how nature and grace exist and live in an intimate union, made more intimate precisely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("because")]), _vm._v(" they are distinct realities (thereby addressing de Lubac’s concern that grace not get so cordoned off from the reality of nature that it becomes irrelevant)."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-030-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-030"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Scheeben scholars have long noticed his insistence that grace must be defined over against nature, which cannot be done unless nature is granted its own self-subsistent reality independent of grace. For example, Aidan Nichols boldly puts it this way:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Right from his earliest work, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natur und Gnade")]), _vm._v(" of 1861, Scheeben has insisted on an extremely sharp distinction between nature and supernature, nature and grace. Indeed, were one [to go] looking for texts to illustrate what early twentieth-century critics of neo-Scholasticism called “extrinsicism” and mid-twentieth-century theologians of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nouvelle théologie")]), _vm._v(" movement [named] “a two-storey model” of the nature/grace relationship, one could do a lot worse than quarry some texts from Scheeben’s writings."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-029-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-029"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("What is more, Scheeben clearly held to a theory of man’s two-fold end, an idea that de Lubac found especially repugnant but which Scheeben seems to have taken for granted, based on the irrefragably obvious anthropological data in front of him (and us) of stunted human ambitions terminating in death. In his words: “Rational creatures, with the nature they have, cannot improve indefinitely. Their progress lasts just so long as the development of their natural faculties will last. But since their natural faculties are finite, the development of rational creatures must also have a determined and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limited")]), _vm._v(" end.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-028-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-028"
    }
  }, [_vm._v("53")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY-T1"
  }, [_vm._v("Similarly, Scheeben anticipates the teaching of Pope Pius XII in his 1950 encyclical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Humani Generis")]), _vm._v(" when he frankly asserts the possibility that God could have given man—had he so chosen—a purely natural end: “In addition to the supernatural order of human development established, revealed, and inaugurated by Christ, man has a natural order, based on his nature. This would be the permanent order destined for man if God had not decreed something better. . . . This means that a purely natural state would be possible, that is, a state without any genuine supernatural elements.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-027-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-027"
    }
  }, [_vm._v("54")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("So important for Scheeben is this rigid distinction between nature and grace that he finds it not just in the Thomist commentary-tradition (where all agree it is to be found, at least in the vast majority of authors), and not just in Thomas himself (contrary to de Lubac’s views); but he also traces the distinction back to the early fathers of the church (which de Lubac presumably would have found preposterous). These fathers, he claims, “insisted that grace does not merge with nature and that it even possesses a certain autonomy.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-026-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-026"
    }
  }, [_vm._v("55")])])]), _vm._v(" To add to the anti-de-Lubac side of the ledger, adding insult to injury, as it were, other passages imply that Scheeben would have been quite flabbergasted by de Lubac’s claim that the pure-nature thesis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("led")]), _vm._v(" to secularism. For him quite the opposite is true:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("My cherished aim is to bring out the supernatural character of the Christian economy of salvation in its full sublimity, beauty, and riches. The main task of our time, it seems to me, consists in propounding and emphasizing the supernatural quality of Christianity, for the benefit of both science and life. Theoretical as well as practical naturalism and rationalism, which seek to throttle and destroy all that is specifically Christian, must be resolutely and energetically repudiated."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-025-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-025"
    }
  }, [_vm._v("56")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In other words, without a resolute distinction between nature and grace, apologetics becomes impossible, which was also a principle of neo-Thomist attacks on de Lubac.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Astute observers will notice, however, a decided shift in accent that has taken place here from the standard neo-Thomist approach to apologetics. As Gerald McCool points out, standard manual apologetics, based on Thomas’s treatment of the so-called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("praeambula fidei")]), _vm._v(" (truths of natural theology that could be proved by reason alone), started with purely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rational")]), _vm._v(" arguments (for the existence of God and the like) and only then proceeded to those truths that could be known solely by faith. According to these Roman Thomists: “By preserving that distinction [between faith and reason], scholastic philosophy could mount strong philosophical arguments for the credibility of revelation without compromising the transcendence of Christianity’s revealed mysteries.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-024-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-024"
    }
  }, [_vm._v("57")])])]), _vm._v(" But then—at least in McCool’s analysis—that style of apologetics had completely lost its ability to address the operative assumptions of the “cultured despisers” of Christianity living in the nineteenth century:")]), _vm._v(" "), _c('p', {
    staticClass: "EX-T2"
  }, [_vm._v("Late nineteenth-century idealists considered the historical “facts of Christian revelation” proclaimed by its authentic witnesses as matters of no significance to them. Since man’s interior life of consciousness required no knowledge of such external facts either for its intellectual or for its moral development, historical Revelation could be simply dismissed out of hand. Even if Christ had lived, and [even] if the alleged witnesses of Revelation had told the truth, these were just external facts of history. They were no different from thousands of other singular facts which ancient historians could verify. Brute, singular facts like these were completely “extraneous” to the vital needs of a consciousness whose immanent development must be directed by its own universal laws. On principle then, extrinsic historical facts, like the life of Christ or the preaching of St. Paul, could not be matters of concern either to the philosopher or to the philosophically enlightened intellectual. He had no need to know them. In fact, since they were useless distractions which might impede the progress of his inner life, he would be well advised to ignore them. The current Catholic apologetics had been devised to answer the arguments of eighteenth-century Enlightenment philosophers who were willing to debate the claims of Christian Revelation. But late nineteenth-century idealists had no intention of debating with Christian apologists. As a matter of principle, apologists were to be denied a hearing."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-023-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-023"
    }
  }, [_vm._v("58")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("For all these reasons—so effectively described by McCool—Scheeben realized that apologetics could only be, in the last analysis, simply "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good theology")]), _vm._v(", that is, a theology that displayed the strictly supernatural character of Christianity "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("from the outset")]), _vm._v(". Such a move of course did not mean for Scheeben any concession to liberalism, which the Modernists took as their starting point in order to make the Christian message plausible to their skeptical contemporaries. Quite the contrary, Scheeben was intensely anti-liberal."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-022-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-022"
    }
  }, [_vm._v("59")])])]), _vm._v(" But his stress on the supernatural as the key locus for apologetics does come close to de Lubac’s concern that the church’s supernaturally validated message must be seen to address the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real")]), _vm._v(" concerns of the age. Both Scheeben and de Lubac agree that apologetics will be chasing after a mirage if it vainly tries to address putatively self-sufficient secularists based on arguments drawn from their own self-justifying and closed-off rationalism."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-021-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-021"
    }
  }, [_vm._v("60")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("But where Scheeben shows his greatest divergence from the manual school is in his next step: his insistence that nature and grace must be kept conceptually distinct in order to make their “nuptial” union more effective: “When grace is transformed into the light of glory, the union will become an indissoluble spiritual marriage, a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matrimonium spirituale ratum et consummatum")]), _vm._v(". The freedom of nature at the side of grace will cease, because it will be thoroughly pervaded by grace and taken up into grace.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-020-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-020"
    }
  }, [_vm._v("61")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Ludwig Wittgenstein famously said that we are bewitched by language. Metaphors, images, analogues are our fate. Under that rubric, Scheeben’s change of imagery has a way of blocking the worst implications of the notorious two-tier model of the nature/grace relationship, with a “supernature” sitting atop nature, like a penthouse atop a skyscraper. As Nichols explains:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Scheeben’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principal")]), _vm._v(" organizing metaphor for the nature/grace relation is very different. It is drawn not from architecture but from marriage. It is nuptiality. Yes, he makes a sharp ontological distinction between nature and grace. But he treats nature and grace as intimately conjoined in a matrimonial bond, co-inhabiting, according to the divine covenant, in a connubial relationship, inter-penetrating in life and love. Scheeben is not only a theologian of the difference between the natural and the supernatural, he is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the")]), _vm._v(" theologian of their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("connubium")]), _vm._v(" as well."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-019-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-019"
    }
  }, [_vm._v("62")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Of course a mere change of imagery won’t accomplish much without an argument demonstrating "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("why")]), _vm._v(" nature and grace belong together in married bliss. For that we must turn to what is perhaps Scheeben’s most radical move: his grounding of the nature/grace relation in the bond between the human and divine natures of Christ in the hypostatic union. Scheeben points out that Christ’s human nature is (of course) a part of creation, but not his divine nature—which is, well, divine. While this sounds obvious (and is), its implications are vast. For one thing it means that God’s power to create and sustain the universe in being is not the same as his power to become incarnate (which distinction is the ground for the distinction between grace and nature, even though God created graciously); and since the whole point of the incarnation is to restore man to friendship with God, this means that the union between man and God effected by grace requires far more than “topping off” nature with a superadded gift:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("In the ordinary created thing, God is present only as its maker and conserver. Without His presence in this way, things could not exist. But in the soul having grace He is present as sanctifier, giving Himself to the creature and sharing with him the holiness of His own being. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This recalls the way in which God the Father is in His only-begotten Son")]), _vm._v(". . . . Thus, as the presence of the Father in His Son is different from His presence in creatures, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("similarly")]), _vm._v(" the presence of the Holy Ghost in the souls of the just is different from His ordinary manner of dwelling in creatures."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-018-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-018"
    }
  }, [_vm._v("63")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("That Scheeben means the word “similarly” as no mere rhetorical flourish or as a kind of vague resemblance becomes apparent when he goes on to establish what the grounding of the nature/grace relationship in the incarnation actually entails: now we should no longer speak of mere adoption but of something "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("between")]), _vm._v(" “adoptive” and “natural” sonship, something that, in his words, “closely interlaces the adoptive sonship with natural sonship.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-017"
    }
  }, [_vm._v("64")])])]), _vm._v(" Elsewhere, he radicalizes the Johannine concept that believers are “born of God” (John 1:13c) in this way:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Every child that is born receives its nature from its father. Therefore, the Second Person of the Holy Trinity is called Son and the First is called Father, because the Latter [that is, the Father] has shared His own Divine Nature of being with the Former [the Son]. . . . When through grace we receive a sharing of the Divine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature")]), _vm._v(" and of the divine life, it is then true "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in a strict sense")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("im eigentlichen Sinne")]), _vm._v("] that we are born of God."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-016"
    }
  }, [_vm._v("65")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Especially in his later book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mysteries of Christianity")]), _vm._v(" Scheeben hammers away at this point: just as the hypostatic union means the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("substantial")]), _vm._v(" union of God and man in Christ (“hypo-static” being the Greek-rooted equivalent to the Latin-rooted word “sub-stantial”), so too the union of God with the Christian is “similarly” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("substantial")]), _vm._v(". Indeed, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("as")]), _vm._v(" substantial, this union means that grace can no longer be conceived as coming to man from without:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Thus the incarnation of the Son of God is the real basis for the adoption of the human race, and likewise conducts that adoption to a consummation that is unique in its sublimity. . . . This fatherhood is not merely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("imitated")]), _vm._v(" in God’s relationship to man, out of sheer grace, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is joined to man substantially")]), _vm._v(". . . . The incarnation raises the human race to the bosom of the eternal Father, that it may receive the grace of sonship with all of its implied dignities "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and rights")]), _vm._v(" by a real contact with the source, rather than by a purely gratuitous influx from without."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-015"
    }
  }, [_vm._v("66")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("“Rights-talk” of course entails talk of obligations: If I have a right to free speech, the government has an obligation to respect that right and cannot throw me into jail for publishing a broadsheet. If I have a right to the free exercise of religion, you have an obligation not to interfere with that right. If I decide to worship Amon-Re or decide to go off on a tree-hugging tour of Crete in order to offer myself up to chthonic feminist deities, you’re just going to have to grit your teeth and put up with my folly. If I have a right to privacy, you have an obligation not to tap my phone or record my phone conversations without my knowledge or permission."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-014"
    }
  }, [_vm._v("67")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Given that indissoluble connection between rights and obligations, one would think that Scheeben would shy away from speaking of any claim we have on God, or any “right” we have over God, that approach being the surest way to undermine—indeed deny—the gratuity of grace. Of course, he would grant that nothing in the sin of Adam and Eve ever obligated God to save them and their progeny by sending his Son, which he did solely out of love (John 3:16). But once the incarnation took place, Scheeben frankly speaks of God’s “obligations.” Notice how he uses the modal verb "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must")]), _vm._v(" applied to God here:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("If, then, the human race . . . becomes the body of Christ, and its members become the members of God’s Son, if the divine person of the Son of God bears them in Himself as His own, then, with due proportion, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must")]), _vm._v(" not the divine gift of the Son of God flow over to men, since they are His members? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Must")]), _vm._v(" not God the Father extend to these members the same love as that which He bears for His natural Son, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must")]), _vm._v(" He not embrace them in His Son "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("with one and the same love")]), _vm._v(", inasmuch as they belong to Him?"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-013"
    }
  }, [_vm._v("68")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As Scheeben continues to reflect on this analogy throughout "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mysteries of Christianity")]), _vm._v(", the language he uses grows more radical until his formulations become very nearly eye-popping:")]), _vm._v(" "), _c('p', {
    staticClass: "EX-L1"
  }, [_vm._v("Because of Christ this sonship is no longer a mere adoptive sonship, since we receive it not as strangers but as kinfolk ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("als Verwandte")]), _vm._v("], as members of the only-begotten Son, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can lay claim to it as a right")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("und sie als ein Recht beanspruchen können")]), _vm._v("]. The grace of sonship in us has something of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" sonship of Christ Himself, from which it is derived. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Because we are not mere adoptive children")]), _vm._v(", because we are members of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" Son, we truly enter into the personal relationship in which the Son of God stands to His Father. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In literal truth, and not by simple analogy or resemblance")]), _vm._v(", we call the Father of the Word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("our")]), _vm._v(" Father, and in actual fact He is such not by purely analogous relationship, but by the very "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("same")]), _vm._v(" relationship which makes Him the Father of Christ."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-012"
    }
  }, [_vm._v("69")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In this way Scheeben seems to have answered, by anticipation, the objections raised in the twentieth century."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-011-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-011"
    }
  }, [_vm._v("70")])])]), _vm._v(" Yes, even when all these points are conceded, much is lost when the concepts of nature and grace are too quickly collapsed into each other. Yes, the existence of natural law itself testifies to ends purely natural (ethics being fundamentally a teleological discipline). Yes, the case of Aristotle’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nicomachean Ethics")]), _vm._v(" proves that a purely human “thriving” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eudaimonia")]), _vm._v(") is an entirely appropriate standard for adjudicating purely intra-human ethical issues. Yes, Thomas (in one set of texts) insists that man has a twofold end, one natural and the other supernatural, one set forth in natural law and the other in divine revelation. But as early as his book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(" we find Scheeben insisting that for a Christian natural law has already been subsumed into the divine “law” of discipleship, of sonship, so that for a Christian there really is no such thing as an independent natural law:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Who can fail to perceive . . . that the doctrine of supernature, which is an elevation of human nature above its own level, clarifies and specifies the transcendence of Christian morality over all philosophical, rational, and rationalistic morality. . . . "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophical ethics, in the sense of a system set up in opposition and defiance against theological morality, is unquestionably not a true and genuine morality")]), _vm._v(". For in the present order purely natural relationships do not exist alone and apart, and therefore cannot be made to prevail in isolated self-sufficiency."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-010"
    }
  }, [_vm._v("71")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Even more ringingly, in the Epilogue to this early book and just a few pages before its end, Scheeben calls for an end to a Christian ethics conceived as a heteronomous imposition of alienating rules. In Christian discipleship morality is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lifted up")]), _vm._v(" to something greater and higher—not in the Hegelian sense of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aufgehoben")]), _vm._v(" (suspended, rendered invalid), but in the sense of being raised up to make us what we have always been destined to be:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("How poverty-stricken and mean Christian morality appears when it is regarded merely as the morality of man (that is, the ethics based on man’s natural moral dignity as found in his reason and free will) rather than as the morality of the sons of God! . . . To grasp the truth that we ­really are Christ’s brothers, we must go into the question of our conformity with Him in His divine no less than in His human nature. And grace may not be regarded merely as a corroborating factor in moral life; it must be apprehended and presented as the new foundation of that life, pertaining to a higher order. Then we shall develop a true moral theology, as distinct from a moral philosophy. Then we shall be able to preach from the pulpit a morality that shares in the excellence of dogmatic theology, a morality rooted in faith, grace, and the mysteries of Christianity."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-009"
    }
  }, [_vm._v("72")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In other words, and in conclusion, the knotty and still unresolved debate over the nature/grace relationship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can")]), _vm._v(" be resolved, but only by grounding that secondary problem in the prior and greater mystery of the incarnation. After all, the incarnation is that mystery that Thomas himself called the one that “among the divine works most especially exceeds reason; for nothing can be thought of which is more marvelous than this divine accomplishment, that the true God, the Son of God, should become true man” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summa contra Gentiles")]), _vm._v(" IV, 27.1). And one of the most astonishing parts of that marvel is that Jesus, the very incarnate Son of God, could say to us, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("jam non dico servos . . . vos autem dixi amicos")]), _vm._v(": “I no longer call you servants, but friends” (John 15:15).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("All that now remains as the task for the rest of this chapter will be to present the results of the preceding analysis (that is, to summarize what can now be reliably said of the nature/grace relation) and then to describe why this seemingly arcane issue "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("matters")]), _vm._v(", for indeed it does matter, often in surprising ways.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("As to results, I think it can now be said that both sides in this debate are right, in their own limited way. Although, as we have seen, the terms “extrinsicist” and “intrinsicist” do not denote the true position of any of the authors treated here, there are differences of approach that can perhaps be better denominated by these terms (which are admittedly my neologisms): "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("continuitists")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("discontinuitists")]), _vm._v(". The first group, best represented by de Lubac and one side of Thomas (who did, after all, say that grace builds on nature), insists on a continuity between nature and grace, lest the life of grace come to seem quite irrelevant to human concerns. The second, best represented by most of the Baroque commentators on Thomas and revived recently by Steven Long and Lawrence Feingold, and represented also by certain utterly clear texts from Thomas himself, insist on the discontinuity between nature and grace, lest grace be seen merely as a way for humans to realize their full potential (that is, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("their")]), _vm._v(" full potential, rather than finding the specific Christian mission God intends for every baptized Christian, which often leads to martyrdom and in all cases leads to a life of self-denial and taking up one’s cross)."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-008"
    }
  }, [_vm._v("73")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Both concerns are legitimate, and both positions find (limited) validation in Thomas himself. But the positions are not strictly contradictory, even if Thomas never seemed to have realized the tension, at least in terms of contemporary debate. But, if Scheeben is right, the two can only be reconciled if the imagery of the debate moves away from architecture and becomes nestled in the imagery of love and marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Recall what was said at the outset of this chapter: the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grace")]), _vm._v(" is, ultimately, a matter of love; but not love in the romantic sense, a protection against the cold winds of existence, the kind of love the poet Matthew Arnold spoke of in “Dover Beach.” No, this is a love that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demands")]), _vm._v(", that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("goes beyond")]), _vm._v(" nature and its capacities, that makes no exceptions and brooks no opposition. As Balthasar says so well:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Thus the principle is affirmed that the calling to love is an absolute one, admitting of no exception, and so ineluctable that failure to observe it is tantamount to total corruption. Let there be no doubt. We are here to love—to love God and to love our neighbor. Whoever will unravel the meaning of existence must accept this fundamental principle from whose center light is shed on all the dark recesses of our loves. For this love to which we are called is not a circumscribed or limited love, not a love defined, as it were, by the measure of our human weakness. It does not allow us to submit just one part of our lives to its demands and leave the rest free for other pursuits; it does not allow us to dedicate just one period of our lives to it and the rest, if we will, to our own interests. The command to love is universal and unequivocal. It makes no allowances. It encompasses and makes demands upon everything in our nature: “with thy whole heart, with all thy soul, and with all thy mind.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-007"
    }
  }, [_vm._v("74")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In finding legitimacy in both sides of the debate, I am not trying to be namby-pamby, wishy-washy, or any of the other terms that afflict theological peacemakers. Rather, my point to stress here is that the two positions come out of deep pastoral concerns; for what theologians on both sides recognize, as said above, is that this debate matters. Take, for example, Feingold’s worry that, if grace is seen as too continuous with nature, people will take their salvation as their due: “[O]ne of the great pastoral problems of our time is that so many people, Catholics and non-Catholics alike, take Heaven for granted as something somehow due simply to natural goodness. This view debases Heaven by naturalizing it.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-006"
    }
  }, [_vm._v("75")])])]), _vm._v(" We have all been to funerals and wakes, I suspect, where a kind of dreamy Americanized eschatology is at work, where the deceased is eulogized as already in heaven, often in the most vulgarized terms. Thus, uncle Wilbur, an avid golfer, will be hymned as now enjoying swinging his nine iron in that great Country Club in the sky."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-005"
    }
  }, [_vm._v("76")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("This same breezy attitude also affects the attitude of many ordinary Catholics as they approach the sacraments. Paul’s admonition to approach them “worthily” seems largely to have fallen into desuetude. But the warning is clear: “Therefore, whoever eats the bread and drinks the cup of the Lord in an unworthy manner will be guilty of sinning against the body and blood of the Lord. . . . If we judged ourselves, we would not come under judgment. When we are judged by the Lord, we are being disciplined, so that we will not be condemned with the world” (1 Cor. 11:27, 31–32). Sounding almost like an extrinsicist, Paul further asks his congregation: “Did the word of God originate with you?” (1 Cor. 14:36).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("This same worry actually, was de Lubac’s concern, although it often goes unrecognized in the secondary literature (on both sides: those attacking and those supporting him). For soon after Vatican II de Lubac began attacking any lazy identification of nature and grace, especially in a lecture he delivered at Saint Louis University in 1968:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Does not such an “openness” [or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aggiornamento")]), _vm._v("] become a forgetfulness of salvation and of the gospel, a tending toward secularism, a loosening of faith and morals? Finally, this “openness” becomes for others a loss of identity, in a word, the betrayal of our obligation toward the world. Because the Council, following the desire of John XXIII, did not wish either to define new dogmas or to pronounce anathemas, many conclude that the church no longer has the right to judge anything or anyone; they recommend a “pluralism” which is not the pluralism of the theological schools but that of entirely different beliefs from those of the normative faith. . . . The word “renewal” can cover a multitude of abuses!"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-004"
    }
  }, [_vm._v("77")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Of course de Lubac never abandoned his view that a heavy stress on pure nature, independent of grace and sufficient to itself, had long since become jejune. Nor, one suspects, would he have been entirely happy with an excessive stress on human passivity when the human person meets grace, a position perhaps due to his membership in the Society of Jesus, a religious order whose members tend to stress, over against other schools (Thomist above all), the active freedom of the human will "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vis-à-vis")]), _vm._v(" God’s offer of grace. That, however, is a topic for a later chapter. But before getting to that quite complex issue, we must first address how creation—very much including created human nature—has been affected by sin and how God “justifies” (puts right) that now marred creation.")]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-080"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-080-backlink"
    }
  }, [_vm._v("1")]), _vm._v(". It is this last meaning that Thomas stresses the most: “We should note that the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(" is derived from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nascendo")]), _vm._v(" [being born]. Hence the nativity of living beings—that is, of animals and plants—was first called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(", as though the word were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nascitura")]), _vm._v(" [something that is being born]. Then the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(" was extended to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("principle")]), _vm._v(" of this nativity. And because the principle of such nativity is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("internal")]), _vm._v(", the name ‘nature’ was further employed to designate the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("interior principle of movement")]), _vm._v(". . . . And because natural motion, especially in procreation and generation, has as its term the essence of a species, that essence of a species—signified by its definition—is called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nature")]), _vm._v(".” Thomas Aquinas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quaestio disputata de unione Verbi incarnati")]), _vm._v(", art. 1; emphases added. This latter meaning has now won out as the primary one: “By far the commonest native meaning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(" is something like sort, kind, quality, or character. When you ask, in our modern idiom, what something ‘is like,’ you are asking for its "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(". When you want to tell a man the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura")]), _vm._v(" of anything you describe the thing.” C. S. Lewis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies in Words")]), _vm._v(" (Cambridge: At the University Press, 1960), 24.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-079"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-079-backlink"
    }
  }, [_vm._v("2")]), _vm._v(". Lewis: “Since "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natural")]), _vm._v(" can mean ‘having due affection,’ or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pius, unnatural")]), _vm._v(" of course means the reverse. Thus old Hamlet’s ghost says that, while all murder is ‘most foul,’ his own murder was ‘strange and unnatural,’ because it was fratricidal. Anything which has changed from its sort or kind ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nature")]), _vm._v(") may be described as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unnatural")]), _vm._v(", provided that the change is one the speaker deplores. Behavior is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unnatural")]), _vm._v(" or ‘affected,’ not simply when it is held to be a departure from that which a man’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nature")]), _vm._v(" would lead to of itself, but when it is a departure for the worse. When the timid man forces himself to be brave, or the choleric man to be just, he is not called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unnatural")]), _vm._v(". ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unnatural")]), _vm._v(" vices’ are so called because the appetite has exchanged its characteristic and supposedly original bent . . . for one which most men think worse. (Perpetual continence, though equally a departure from [nature], would be, and is, called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unnatural")]), _vm._v(" only by those who disapprove of it.)” Lewis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies")]), _vm._v(", 43–44; all emphases in the original.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-078"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-078-backlink"
    }
  }, [_vm._v("3")]), _vm._v(". One relic of that range of meanings referring to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not-required")]), _vm._v(" survives in English in the term used by restaurants: “gratuity,” meaning a tip offered to the waiter as something added on to the bill in gratitude for excellent service. Granted, as tips become more socially expected, not giving a tip can look conspicuous; and some restaurants even affix a (now quite misnamed) “gratuity” to the bill. But outside of that context, no one is legally obliged to pay a tip, provided of course one is willing to endure some ugly stares on leaving the restaurant, whereas not paying a bill can land one in Small Claims Court. The point is that restaurateurs have a right in law to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demand")]), _vm._v(" payment of a bill; but a tip, precisely as a gratuity, is unowed, not required in law, and thus “graciously” given. There is also a pejorative connotation to the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratuitous")]), _vm._v(", as in a “gratuitous insult.” But there too the root meaning of “undeserved” or “unearned” is preserved.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-077"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-077-backlink"
    }
  }, [_vm._v("4")]), _vm._v(". Jean Daujat, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Theology of Grace")]), _vm._v(", trans. by a nun of Stanbrook Abbey (New York: Hawthorn Books, 1959), 10–11.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-076"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-076-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". Daujat, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology of Grace")]), _vm._v(", 11; emphasis added. This insight also of course has scriptural warrant: “Love is patient, love is kind. It does not envy, it does not boast, it is not proud. It is not rude, it is not self-seeking, it is not easily angered. It keeps no record of wrongs. Love does not delight in evil but rejoices with the truth. It bears all things, believes all things, hopes all things, endures all things” (1 Cor. 13:4–7).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-075"
    }
  }, [_c('p', {
    staticClass: "FN-T1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-075-backlink"
    }
  }, [_vm._v("6")]), _vm._v(". On the last page of his book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The First Three Minutes")]), _vm._v(", Steven Weinberg famously said: “The more the universe seems comprehensible, the more it also seems pointless.” As the theologian Larry Chapp points out, the concept of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pointless")]), _vm._v(" semantically overlaps with that of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gratuitous")]), _vm._v(". Humans often do pointless things “gratuitously,” that is, for no ulterior purpose but just for the sheer fun of it, such as children building sandcastles on the beach, or prehistoric societies etching geometric patterns in pottery. Whimsy is itself a kind of grace. Weinberg, in other words, is “close to the kingdom” but not quite there (yet). In Proverbs, a personified Wisdom speaks of her playful delight at God’s creation: “When he marked out the foundations of the earth, I was beside him like a little child and was daily his delight, rejoicing before him always, rejoicing in his inhabited world and delighting in the sons of men” (Prov. 8:29c–31). On this passage see Hugo Rahner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Man at Play")]), _vm._v(" (New York: Herder and Herder, 1967), 20, who notes that the Septuagint translates the Hebrew word for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rejoicing")]), _vm._v(" with the Greek word for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dancing")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("choreuzein")]), _vm._v("). For the idea that all culture is a form of gratuitous, “pointless” play, see Johan Huizinga, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homo Ludens: A Study of the Play Element in Culture")]), _vm._v(" (Boston: Beacon Press, 1950).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-074"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-074-backlink"
    }
  }, [_vm._v("7")]), _vm._v(". Daujat, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology of Grace")]), _vm._v(", 46.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-073"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-073-backlink"
    }
  }, [_vm._v("8")]), _vm._v(". As the great medieval Dominican Albertus Magnus pointed out, nothing is more “extrinsic” to nature than the resurrection: “The resurrection is in no way a natural process; the fact that it is a final goal does not make it natural. Of course, if by ‘nature’ one means that natural being that man is, it can be said that man exists for the sake of resurrection; but this ‘for the sake of’ refers to the final purpose of the creation of man, not of nature. The ground of creation is not, in fact, nature; hence the final goal of creation is not actually the final goal of nature.” Albertus Magnus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Resurrectione")]), _vm._v(", tractate 1, q. 3; cited in Hans Urs von Balthasar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theo-Drama: Theological Dramatic Theory")]), _vm._v(", Vol. V: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Last Act")]), _vm._v(", trans. Graham Harrison (San Francisco: Ignatius Press, 1998), 375.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-072"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-072-backlink"
    }
  }, [_vm._v("9")]), _vm._v(". The invention of these two terms, at least as they are used in the nature/grace debate, has often been attributed to the French Catholic philosopher Maurice Blondel (1861–1949), but in fact, whether or not he originated them, he used them to express two equally "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unacceptable")]), _vm._v(" extremes: “I shall make use of certain barbarous neologisms with a view to fixing attention and throwing into relief the exclusive character of each thesis. . . . [They] are opposite extremes, but of the same kind, based upon similar habits of mind, suffering from analogous philosophical lacunae, and aggravating one another by their conflict.” Maurice Blondel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History and Dogma")]), _vm._v(", trans. Alexander Dru and Illtyd Trethowan (Grand Rapids, MI: Eerdmans, 1964/1904), 225. According to Blondel, monarchist Catholics were able to ally themselves with the atheist Charles Maurras because their extrinsicism prevented them from seeing that Christians must act as a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("leaven")]), _vm._v(" transforming society from within. See Peter J. Bernardi, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maurice Blondel, Social Catholicism, and Action française: The Clash over the Church’s Role in Society during the Modernist Era")]), _vm._v(" (Washington, DC: Catholic University of America Press, 2009), 167–73, 189–207. On the other side of the ledger, it should also be noted that Blondel vigorously denied that his attacks on “extrinsicism” meant he was an intrinsicist, which in his terms meant being a pragmatist or a Kantian: “He recognized the ontological implications of first principles, the objective value of knowledge in all its stages, the objective truth of concepts, and the living immanence of realities in them.” Henri Bouillard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blondel and Christianity")]), _vm._v(", trans. James M. Somerville (Washington, DC: Corpus Books, 1969), 39, citing Maurice Blondel, “fidélité conservée par la croissance même de la tradition,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revue Thomiste")]), _vm._v(" 40 (1936): 611–25.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-071"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-071-backlink"
    }
  }, [_vm._v("10")]), _vm._v(". D. Palmieri, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tractatus de gratia divina actuali")]), _vm._v(" (1885), 7–8; emphases added. Reductionists will obviously object especially to Palmieri’s first point, that “higher” developments represent something genuinely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("new")]), _vm._v(", unexpected and “unowed.” But reductionism collapses as soon as one realizes the impossibility of writing a research article on, for example, “The Role of Atoms in Supply-Side Economics.” The chemist and philosopher of science Michael Polanyi gets at something like the same point when he says: “[I]t is as meaningless to represent life in terms of physics and chemistry as it would be to interpret a grandfather clock or a Shakespeare sonnet in terms of physics and chemistry; and it is likewise meaningless to represent mind in terms of a machine or of a neural model. Lower levels do not lack a bearing on higher levels; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they define the conditions of their success and account for their failures, but they cannot account for their success, for they cannot even define it")]), _vm._v(".” Michael Polanyi, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Personal Knowledge: Toward a Post-Critical Philosophy")]), _vm._v(" (Chicago: University of Chicago Press, 1962), 18, 382; Polanyi’s italics.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-070"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-070-backlink"
    }
  }, [_vm._v("11")]), _vm._v(". Hans Urs von Balthasar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Christian State of Life")]), _vm._v(", trans. Sister Mary Frances McCarthy (San Francisco: Ignatius Press, 1983), 67; Balthasar’s italics.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-069"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-069-backlink"
    }
  }, [_vm._v("12")]), _vm._v(". Balthasar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian State of Life")]), _vm._v(", 67–68. As Pope St. Leo the Great (c. 400–461) says so well: “As God does not change by his condescension, so man is not swallowed up by being exalted.” Leo the Great, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistula 28: ad Flavianum")]), _vm._v(", 3–4 ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("PL")]), _vm._v(" 54, 763–67): “Sicut enim Deus non mutatur miseratione, ita homo non consumitur dignitate.” I owe this reference to Fr. Richard Schenk, O.P., to whom thanks.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-068"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-068-backlink"
    }
  }, [_vm._v("13")]), _vm._v(". Pope’s debt to Pascal has long been recognized, as here: “Man’s greatness lies in his capacity to recognize his wretchedness. A tree does not recognize its wretchedness. So it is wretched to know one is wretched, but there is greatness in the knowledge of one’s wretchedness.” Blaise Pascal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pensées")]), _vm._v(", trans. Honor Levi (Oxford: Oxford University Press, 1995), 36–37. For that reason, all the Christian saints recognize that no matter how intimate our union with God becomes through grace, the distance between God and the creature will never be abrogated: “Man is indeed called to love, but only in a manner that permits him to live to the full his condition as creature. He not only may, but must, strive for the highest degree of love; but this highest degree must be accompanied by the most complete realization of his true state as creature. In a word, love must have the inner form of dependence and submission; it must be identical with the glorification of the Eternal Archetype by means of reverential service” (Balthasar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian State of Life")]), _vm._v(", 68). This duality is also reflected in two sayings of Jesus: “I no longer call you servants, but friends” (John 15:15); but: “So you too, when you have done all that is commanded of you, say: ‘We are unworthy servants; we have only done what is our duty’ ” (Luke 17:10).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-067"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-067-backlink"
    }
  }, [_vm._v("14")]), _vm._v(". William R. O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Natural Desire for God")]), _vm._v(", The Aquinas Lecture, 1948 (Milwaukee: Marquette University Press, 1948), 18–19.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-066"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-066-backlink"
    }
  }, [_vm._v("15")]), _vm._v(". “O God, thou who art loved, wittingly or unwittingly, by everything that is capable of loving. . . .” Augustine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Soliloquies")]), _vm._v(" I, 2.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-065"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-065-backlink"
    }
  }, [_vm._v("16")]), _vm._v(". “Shall we say, as St. Thomas Aquinas was to answer, that since God has made man a rational animal, the natural light of reason must be able naturally to perform its proper function, which is to know things as they are, and thereby to know truth? Or shall we say with St. Augustine, that truth being necessary, unchangeable, and eternal, it cannot be the work of a contingent, mutable, and impermanent human mind interpreting unnecessary, changeful and fleeting things? Even in our minds truth is a sharing of some of the highest attributes of God; consequently, even in our minds, truth is an immediate effect of the light of God.” Etienne Gilson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Unity of Philosophical Experience")]), _vm._v(" (San Francisco: Ignatius Press, 1999; originally published in 1937), 43–44. See as well: Etienne Gilson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pourquoi saint Thomas a critiqué saint Augustin")]), _vm._v(" (Paris: J. Vrin, 1981): “Le thomisme serait donc né . . . d’une décision philosophique pure. Opter contra la doctrine de Platon, pour celle d’Aristote, c’était s’obliger à reconstruire la philosophie chrétienne sur d’autres bases que celles de saint Augustin” (126).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-064"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-064-backlink"
    }
  }, [_vm._v("17")]), _vm._v(". O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Desire for God")]), _vm._v(", 24–25; emphasis added. The internal quotation is from Bonaventure’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De mysterio Trinitatis")]), _vm._v(" I, 1, 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-063"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-063-backlink"
    }
  }, [_vm._v("18")]), _vm._v(". See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I, q. 84, a. 5 and I, q. 88, a. 3. Admittedly, in these two passages Thomas seems to be trying to harmonize his position with Augustine’s, not disagree with it; but that is the usual habit among medieval theologians, as one scholar rightly notes: “Thomas probably did not yet recognize the immense doctrinal distance between the historical Augustine and his own epistemology. Yet Aquinas was hardly the first scholastic to interpret the Latin Father somewhat loosely.” Bernhard Blankenhorn, O.P., “Aquinas as Interpreter of Augustinian Illumination in Light of Albertus Magnus,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nova et Vetera")]), _vm._v(", English Edition, Vol. 10, No. 3 (Summer 2012): 689–713; here 699.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-062"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-062-backlink"
    }
  }, [_vm._v("19")]), _vm._v(". For Thomas, this arduous journey to God establishes the creaturely basis for the theological virtue of hope, as he says here: “Now hope implies desire accompanied by the rousing of one’s spirit ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("animi")]), _vm._v("] as tending to something arduous ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quasi in quoddam arduum tendens")]), _vm._v("]” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De veritate")]), _vm._v(" q. 28, a. 4). The renowned Thomist moral theologian Servais Pinckaers explains this passage as follows: “Hope has for its object "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bonum arduum")]), _vm._v(", an arduous good that is difficult to attain. The object of hope is one from which we are separated by a great distance, a distance which makes us simultaneously afraid that we will not be able to achieve it, while at the same time spurring us on with the effort required to achieve it.” Servais Pinckaers, O.P., “The Natural Desire to See God,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nova et Vetera")]), _vm._v(", English edition, Vol. 8, No. 3 (Summer 2010): 627–46, here 643.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-061"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-061-backlink"
    }
  }, [_vm._v("20")]), _vm._v(". Thomas Aquinas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De veritate")]), _vm._v(" q. 5, a. 2, ad 11; and: “Although uncreated truth exceeds all created truth, yet there is nothing to prevent created truth from being better known to us. Things that are less known in themselves are known better by us” (ibid., q. 10, a. 12, ad 6).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-060"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-060-backlink"
    }
  }, [_vm._v("21")]), _vm._v(". O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Desire for God")]), _vm._v(", 26–27; emphasis added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-059"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-059-backlink"
    }
  }, [_vm._v("22")]), _vm._v(". Pascal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pensées")]), _vm._v(", 8.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-058"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-058-backlink"
    }
  }, [_vm._v("23")]), _vm._v(". O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Desire for God")]), _vm._v(", 29–30; emphases added. As the author points out: “It is important . . . to see that to desire to know an object is not the same as desiring an object already known” (ibid., 35), a distinction that was lost on Augustine but is crucial for resolving this knotty issue.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-057"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-057-backlink"
    }
  }, [_vm._v("24")]), _vm._v(". Henri de Lubac, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mystery of the Supernatural")]), _vm._v(", translated by Rosemary Sheed, Introduction by David L. Schindler (New York: Crossroad, 1998), 54, emphasis added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-056"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-056-backlink"
    }
  }, [_vm._v("25")]), _vm._v(". de Lubac, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mystery of the Supernatural")]), _vm._v(", 54–55.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-055"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-055-backlink"
    }
  }, [_vm._v("26")]), _vm._v(". The invocation of the idea of limbo reserved for unbaptized infants (who in this limbo supposedly never notice their deprivation of their supernatural destiny) in order to support the hypothesis of a pure nature, however, soon runs into its own contradictions. Not only does it have to face Col. 1:16 and John 1:1–4 (which assert that all creation came "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("through ")]), _vm._v("Christ and/or the Word), but it must also face its own insistence that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("natura pura")]), _vm._v(" does not actually obtain in the world as it was actually created by God. As Reginald Garrigou-­Lagrange rightly points out: “All theologians agree that this state of pure nature never existed.” Reginald Garrigou-Lagrange, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grace: Commentary on the ")]), _vm._v("Summa theologica "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of St. Thomas, IaIIae, q. 109–14")]), _vm._v(", trans. Dominican Nuns of Corpus Christi Monastery (St. Louis: B. Herder, 1952), 23. Thus, if a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("limbus infantium")]), _vm._v(" does exist, then so does a pure nature untouched by Christ; but this latter is denied by all parties, as it would deny the trinitarian/christological foundation of creation.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-054"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-054-backlink"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gaudium et Spes")]), _vm._v(" §22; cited from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Documents of Vatican II")]), _vm._v(", ed. Walter M. Abbott, S.J. (New York: America House Press, 1966), 221–22; emphasis added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-053"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-053-backlink"
    }
  }, [_vm._v("28")]), _vm._v(". Henri de Lubac, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Surnaturel: Etudes historiques")]), _vm._v(", nouvelle édition, preparée et préfacée par Michel Sales, S.J. (Paris: Desclée de Brouwer, 1991), 483: “Paradoxe de l’esprit humain: créé, fini, il n’est pas seulement doublé d’une nature; il est lui-même nature. Avant d’être esprit pensant, il est nature spirituelle. . . . L’esprit est donc désir de Dieu.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-052"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-052-backlink"
    }
  }, [_vm._v("29")]), _vm._v(". Harm Goris, “Steering Clear of Charybdis: Some Directions for Avoiding ‘Grace Extrinsicism’ in Aquinas,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nova et Vetera")]), _vm._v(", English edition, Vol. 5, No. 1 (Winter 2007): 67–79; here 69.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-051"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-051-backlink"
    }
  }, [_vm._v("30")]), _vm._v(". Bernard Mulcahy, O.P., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aquinas’s Notion of Pure Nature and the Christian Integralism of Henri de Lubac: Not Everything Is Grace")]), _vm._v(", American University Studies, Series VII: Theology and Religion, Vol. 314 (New York: Peter Lang, 2011), 4–5. One might also mention, at a popular level, the famous last line of Georges Bernanos’s novel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Diary of a Country Priest")]), _vm._v(", where the expiring priest said on his deathbed that grace is everywhere, a novelistic echo of the Little Flower’s line “everything is grace”: “Si vous me trouviez morte un matin, n’ayez pas de peine: c’est que Papa le bon Dieu serait venu tout simplement me chercher. Sans doute, c’est une grande grâce de recevoir les Sacrements; mais quand le bon Dieu ne le permet pas, c’est bien quand même, tout est grâce.” Thérèse de L’Enfant de la Sainte Face, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oeuvres Complètes")]), _vm._v(" (Paris: Cerf, 1988), 1009.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-050"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-050-backlink"
    }
  }, [_vm._v("31")]), _vm._v(". This seems to be Garrigou-Lagrange’s position: “one cannot follow St. Thomas by falling into a material literalism.” P. R. Garrigou-Lagrange, “La possibilité de la grâce est-elle rigoureusement démonstrable?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revue thomiste")]), _vm._v(" no. 94 (Mars-Avril 1936), 214, footnote 20: “il ne faut pas, pour suivre saint Thomas, tomber dans un littéralisme matériel.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-049"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-049-backlink"
    }
  }, [_vm._v("32")]), _vm._v(". Steven A. Long, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natura Pura: On the Recovery of Nature in the Doctrine of Grace")]), _vm._v(" (New York: Fordham University Press, 2010), 13, 15; emphasis in the original. Despite his own anti-de Lubac position, O’Connor agrees that Thomas cannot be easily reconciled with himself: “St. Thomas, apparently, flatly denies what he has so vigorously affirmed concerning the existence of a natural desire. Since this is the case, it is difficult to appeal to any text whether for or against a natural desire for God, for one set of texts can always be offset by another.” William R. O’Connor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Eternal Quest: The Teaching of St. Thomas Aquinas on the Natural Desire for God")]), _vm._v(" (New York: Longmans, Green and Co., 1947), 12.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-048"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-048-backlink"
    }
  }, [_vm._v("33")]), _vm._v(". “We call a shoe pointless when it cannot be worn. But God and nature create nothing that is useless.” Aristotle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Heavens")]), _vm._v(" Book I, ch. 4 (271a30). The context here is actually not human artifacts like shoes but, as the title of the treatise indicates, Aris­totle’s discussion of the necessarily circular orbits of celestial bodies. The application of this principle, which properly belongs in Aristotle’s long superseded astronomy, to theological discussions of nature and grace is ironic indeed. At all events, and only adding to the irony, both Baius and Jansenius accepted that premise too, which is why they held that original sin had so devastated human nature and not just merely deprived our first parents of the (supposedly extraneous) grace of original justice: because grace and nature belong together, they reasoned, loss of grace necessarily entails the ruin of nature. Although they came to diametrically different conclusions about the way grace operates in postlapsarian man, they both wanted to stress the devastating effects of original sin on human nature, for which Aristotle’s axiom proved useful. Condemnation of these views obviously required that orthodox theologians make a firmer—or at least less ambiguous—distinction between nature and grace, which then proved an important catalyst for the Thomist commentators. But because the commentators "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("also")]), _vm._v(" accepted Aristotle’s principle that nature does nothing in vain, they were perforce compelled to posit natural ends in man that were independent of his ultimate felicity in heaven. The theses of Baius and Jansenius will be discussed in more detail in the third chapter, on original sin. For purposes of this chapter, all that need be said here is that the condemnation of their heresies forced a more precise distinction to be made, even in our prelapsarian first parents, between nature and grace.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-047"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-047-backlink"
    }
  }, [_vm._v("34")]), _vm._v(". The Stagirite invokes the same principle to biology too, of course: “Again, some members of the class of fishes are neither male nor female, as we see in eels and a kind of mullet found in stagnant waters. But whenever the sexes are separate, the female cannot generate perfectly by herself alone, for then the male would exist in vain, and nature makes nothing in vain.” Aristotle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Generation of Animals")]), _vm._v(" Book II, ch. 5 (741b2). The operation of this principle in the nature/grace debate makes it difficult to account for Paul’s insistence that “creation was subjected to futility, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not by its own choice")]), _vm._v(", but by the will of the one who subjected it” (Rom. 8:20).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-046"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-046-backlink"
    }
  }, [_vm._v("35")]), _vm._v(". The preceding four paragraphs are adapted from my article “Scheeben the Reconciler: Resolving the Nature/Grace Debate,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nova et Vetera")]), _vm._v(", English edition, Vol. 11, No. 2 (Spring 2013): 435–53.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-045"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-045-backlink"
    }
  }, [_vm._v("36")]), _vm._v(". Howard P. Kainz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Existence of God and the Faith-Instinct")]), _vm._v(" (Cranbury, NJ: Susquehanna University Press, 2010).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-044"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-044-backlink"
    }
  }, [_vm._v("37")]), _vm._v(". The prehistoric paintings in the caves of Lascaux in the Dordogne region of southwestern France (made roughly 17,000 years ago) and the even earlier ones at Chauvet in the Ardèche Départment of southern France (dated 30,000 years ago) are notoriously difficult to interpret—since, when they were painted, literacy had not been invented; and without texts to go on, there is no way to interpret why they were made. One suspects, though, based on these passages, that Thomas would hold that the paintings were made for religious reasons.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-043"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-043-backlink"
    }
  }, [_vm._v("38")]), _vm._v(". Although Thomas does not mention the bishop of Hippo directly here, something like Augustine’s view gets expressed in the third objection, to which Thomas offers this reply: “The reason and will are naturally directed to God, inasmuch as He is the beginning and end of nature, but [only] in proportion to nature. But the reason and will, according to their nature, are not sufficiently directed to Him in so far as He is the object of supernatural happiness” (ibid., ad 3). The break with Augustine is now complete.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-042"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-042-backlink"
    }
  }, [_vm._v("39")]), _vm._v(". A point repeated here: “Now everlasting life is a good exceeding the proportion of created nature, since it exceeds its knowledge and desire” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ST")]), _vm._v(" I/II, q. 114, a. 2). Also here: “Man merits not by desiring a happiness which he naturally seeks, but by desiring something special, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("which he does not seek naturally")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quod non naturaliter appetit")]), _vm._v("], such as the vision of God, in which nonetheless as a matter of fact ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("secundum rei veritatem")]), _vm._v("] his happiness does consist” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De veritate")]), _vm._v(" q. 22, a. 7; emphasis added).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-041"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-041-backlink"
    }
  }, [_vm._v("40")]), _vm._v(". Lawrence Feingold, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Natural Desire to See God according to St. Thomas Aquinas and His Interpreters")]), _vm._v(", second edition (Naples, FL: Sapientia Press, 2010). In the majority he includes Denis the Carthusian (1402–71), the Dominicans Thomas de Vio (1469–1534; better known as Cardinal Cajetan), Bartolomé de Medina (1527–1580), Domingo Báñez (1528–1604), and the Jesuit Francisco Suárez (1548–1604). In the minority are the Dominican Domingo de Soto of Salamanca (1494–1560) and the Jesuit Francisco de Toledo (1532–1596).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-040"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-040-backlink"
    }
  }, [_vm._v("41")]), _vm._v(". Feingold, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Desire,")]), _vm._v(" xxxiii.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-039"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-039-backlink"
    }
  }, [_vm._v("42")]), _vm._v(". Feingold, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Desire")]), _vm._v(", 21; emphasis added. The advantage of this distinction is that it gives anthropological grounding to Pascal’s insight that we keep from attending to our relation to God by what he calls "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("divertissements")]), _vm._v(" (distractions): “The only thing that consoles us for our miseries is distraction, yet that is the greatest of our wretchedness. Because that is what mainly prevents us from thinking about ourselves and leads us imperceptibly to damnation. Without it we should be bored, and boredom would force us to search for a firmer way out, but distraction entertains us and leads imperceptibly to death.” Pascal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pensées")]), _vm._v(", 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-038"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-038-backlink"
    }
  }, [_vm._v("43")]), _vm._v(". Steven A. Long, “Obediential Potency, Human Knowledge, and the Natural Desire for God,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("International Philosophical Quarterly")]), _vm._v(" 37 (March 1997): 45–63, here 45; emphases added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-037"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-037-backlink"
    }
  }, [_vm._v("44")]), _vm._v(". Steven A. Long, “On the Loss, and Recovery, of Nature as a Theonomic Principle,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nova et Vetera")]), _vm._v(", English edition, Vol. 5, No. 1 (Winter 2007): 133–83, here 165–66; emphasis added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-036"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-036-backlink"
    }
  }, [_vm._v("45")]), _vm._v(". Thomas is here answering the third objection, which runs: “The act of justice is to pay what is due. But God is no man’s debtor”—which is precisely the objection raised against de Lubac!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-035"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-035-backlink"
    }
  }, [_vm._v("46")]), _vm._v(". Although he does not address them directly, Denys Turner seems to join Long and Feingold here: “For ours is like the condition of the person who is self-deceived: not only is he self-ignorant, but he has somehow managed to hide from himself how it is that he is himself the cause of that ignorance and that he has a reason for remaining in it undisturbed. Therefore, for Thomas it takes grace to know that we are in need of grace. . . . Grace, therefore, does not exactly answer to our desire, as if we knew what our desire is. Grace answers to desires that only it can arouse in us, showing us what it is that we really want: grace is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pure")]), _vm._v(" gift, the gift we could not have known that we wanted until we were given it. . . . And prayer answers to the very desire that prayer itself discovers; prayer uncovers the hidden desire precisely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by")]), _vm._v(" answering it.” Denys Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thomas Aquinas: A Portrait")]), _vm._v(" (New Haven, CT: Yale University Press, 2013), 171–72. Here, however, Turner, in this last line, might be overarguing his case; since petitionary prayer often springs from purely natural needs: “Give us this day our daily bread.” First hunger, then prayer. One way of squaring this circle comes from the recently published “Prayer Journal” of the American novelist Flannery O’Connor, a notebook she kept while at the Iowa Writers’ Workshop in 1946–47: “My dear God, Supplication. This is the only one of the four [types of prayer] I am competent in. It takes no supernatural grace to ask for what one wants and I have asked You bountifully, oh Lord. I believe it is right to ask You too and to ask our Mother to ask You, but I don’t want to overemphasize this angle of my prayers. Help me to ask you, oh Lord, for what is good for me to have, for what I can have and do Your service by having.” Flannery O’Connor, “Journals: My Dear God: A young writer’s prayers,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Yorker")]), _vm._v(" (September 16, 2013): 26–30, here 28.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-034"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-034-backlink"
    }
  }, [_vm._v("47")]), _vm._v(". One problem with de Lubac’s interpretation was his flagrant selectivity in citing the Thomist corpus, a blindspot that recent scholarship has been quick to expose, and this despite his undoubted achievements conceded by all. Mulcahy gives the best overall assessment here: “The general aim of Henri de Lubac’s life’s work was, by his own account, to make the treasures of the Catholic past known and appreciated in the modern world. . . . To a marvelous extent, de Lubac was successful [in] this purpose. He called the Church to acknowledge its Jewish origins, and to a new respect for the Jewish people. His "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Corpus Mysticum")]), _vm._v(" furthered liturgical renewal and infused ecclesiology with a fresh sense of the ancient doctrine that the Eucharist constitutes the Church. Through his scholarly research, he helped spark interest in patristic and medieval exegesis, contributed to the rehabilitation of Origen, and initiated the production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sources chrétiennes")]), _vm._v(", one of the century’s greatest patrological resources. His books on all these topics have been widely read and widely translated, influencing educated Catholics and at least two popes; his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Catholicisme")]), _vm._v(" recently received the extraordinary accolade of being singled out in a papal encyclical, Benedict XVI’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spe salvi")]), _vm._v(", for reminding the Church of the communal nature of salvation. To these achievements must be added his witness of tireless fidelity and self-sacrifice, including his personal bravery in opposing anti-Semitism during the German occupation of France during World War II. Despite all this, it must be admitted that de Lubac’s scholarship was often flawed. This is not surprising when we consider that he did not have the benefit of any instruction beyond his ordination studies, and that his scholarship tended to be more broad than deep. . . . Unfortunately, he was frequently impatient with specialists and more rigorous scholars who opposed his interpretations. In his haste to communicate his discoveries, he sometimes gave very partial readings of textual evidence. We find him, on a number of occasions, using quotations which seem to prove his arguments but which, in their original contexts, do not support him. It might be conceded that de Lubac, on such occasions, intends his quotations for merely rhetorical effect; but, still, quoting authorities out of context does tend to give a false impression.” Mulcahy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aquinas’s Notion of Pure Nature")]), _vm._v(", 147–48.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-033"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-033-backlink"
    }
  }, [_vm._v("48")]), _vm._v(". Politics, both socioeconomic and ecclesiastical, plays its part here too in keeping the debate stretched out, with Milbank the socialist arrayed against the neo-Thomists Feingold and Hütter. If war has been called the conduct of diplomacy by other means, according to some interpreters, the nature/grace debate is the politics of the culture wars pursued in theology’s seminar room. See Sean Larsen, “The Politics of Desire: Two Readings of Henri de Lubac on Nature and Grace,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Modern Theology")]), _vm._v(", Vol. 29, No. 3 (July 2013): 279–310.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-032"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-032-backlink"
    }
  }, [_vm._v("49")]), _vm._v(". I owe this insight to Andrew Swafford, STD, who first pointed out Scheeben’s relevance to me in this debate. The paragraphs below closely track (but with revisions) what I said in “Scheeben the Reconciler,” cited above.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-031"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-031-backlink"
    }
  }, [_vm._v("50")]), _vm._v(". No less a luminary than John Courtney Murray wrote his dissertation in 1938 on Scheeben, later republished as: John Courtney Murray, S.J., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Matthias Joseph Scheeben’s Doctrine on Supernatural Faith")]), _vm._v(" (New York: Edwin Mellen, 1987). See also John Courtney Murray, S.J., “The Root of Faith: The Doctrine of M. J. Scheeben,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theological Studies")]), _vm._v(", Vol. 9 (1948): 20–46.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-030"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-030-backlink"
    }
  }, [_vm._v("51")]), _vm._v(". Fascinatingly, Scheeben is admired by theologians usually taken by most observers to be radically opposed in their outlook, such as Balthasar and Garrigou-Lagrange: “The sympathetic citation of his work by twentieth-century theologians as different as Hans Urs von Balthasar, a child of the so-called ‘new theology’ of the 1940s and 1950s, and Reginald Garrigou-Lagrange, champion, in the years immediately preceding the Second Vatican Council, of ‘strict observance’ Thomism, attests to his mediating role.” Aidan Nichols, O.P., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romance and System: The Theological Synthesis of Matthias Joseph Scheeben")]), _vm._v(" (Denver: Augustine Institute Press, 2010), 19.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-029"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-029-backlink"
    }
  }, [_vm._v("52")]), _vm._v(". Nichols, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romance and System")]), _vm._v(", 288. Cyril Vollert, Scheeben’s Jesuit translator, agrees: “His most notable contribution to Neo-Scholasticism is his service in bringing the supernatural, in its full purity and beauty, back to the center of theological thought.” Cyril Vollert, S.J., “Introduction,” Matthias Joseph Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", trans. Cyril Vollert, S.J. (St. Louis: B. Herder Book Co., 1954), xiii.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-028"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-028-backlink"
    }
  }, [_vm._v("53")]), _vm._v(". Matthias Joseph Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Glories of Divine Grace")]), _vm._v(", trans. by a monk of St. Meinrad’s Abbey (New York: Benziger, 1886), 46; emphasis added. Further: “The Church necessarily supposes that there is a natural goal and end; for it teaches that the end now appointed for nature, consisting as it does in the beatific vision of God, is absolutely supernatural, and is to be communicated to us by a special grace. And yet there must be a necessary [natural] end for nature.” Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", 93.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-027"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-027-backlink"
    }
  }, [_vm._v("54")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", 86–87.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-026"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-026-backlink"
    }
  }, [_vm._v("55")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", xix: “The Greek Fathers . . . considered grace in its supernatural and divine excellence, as a perfection that surpassed even what was true in the created world of nature. They saw grace in its relations with the mysteries of the Trinity, the Incarnation, and the Eucharist. Against rationalistic Nestorianism they pointed out that grace, like the Incarnation, has a supernatural, mysterious connection with the Godhead; against the Manichaeans, Gnostics, and Eutychians they brought to light the difference and opposition between nature and grace. . . . With remarkable penetration and incisiveness these Fathers, notably Cyril of Alexandria, triumphantly combated the naturalist and rationalist tendency that marked Nestorius and that had earlier appeared among the Arians. They remain the best allies in our conflict with modern rationalism” (ibid., xviii-xix).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-025"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-025-backlink"
    }
  }, [_vm._v("56")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace,")]), _vm._v(" xvii.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-024"
    }
  }, [_c('p', {
    staticClass: "FN-T3"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-024-backlink"
    }
  }, [_vm._v("57")]), _vm._v(". Gerald A. McCool, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Neo-Thomists")]), _vm._v(" (Milwaukee: Marquette University Press, 1994), 34.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-023"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-023-backlink"
    }
  }, [_vm._v("58")]), _vm._v(". McCool, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Neo-Thomists,")]), _vm._v(" 47. Blondel, for one, took this objection seriously and in fact it forms the basis for his criticism of “extrinsicism,” as his premier Anglophone biographer points out: “All it [extrinsicism] looks for from facts are signs for the senses and proofs for common sense. . . . It only extracts some abstract ideology from [history] that it then presents as the object of faith, as if that were all there is to the true Christian faith. . . . Such a rudimentary way of reasoning, which is supposed to make us take the first step from facts to dogmas, convinces no one, least of all those who place their faith in reason. . . . It leaves all the key relations extrinsic to each other: the relation of the sign to the thing signified, the relation of facts to the dogmatics superimposed on them. . . . It separates facts and dogmas in such a way that they can only remain at odds with one another, whence the defensive and ultimately defeatist attitude it takes in the face of modern historical studies.” Oliva Blanchette, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maurice Blondel: A Philosophical Life")]), _vm._v(" (Grand Rapids, MI: Eerdmans, 2010), 195.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-022"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-022-backlink"
    }
  }, [_vm._v("59")]), _vm._v(". John Courtney Murray even goes so far as to speak of Scheeben’s “hatred” of liberalism: “One might perhaps best characterize these [early] years by calling them the period in which the one great theological hate of Scheeben’s life was kindled to flaming intensity—his hate of rationalistic and naturalistic religious Liberalism. It may seem strange to speak of hate in connection with a man of Scheeben’s quiet temper; however, the passion does show itself in the texts in which he attacks this particular error.” John Courtney Murray, S.J., “The Root of Faith,” 24. Nichols expresses the same point, albeit without Murray’s psychologizing attribution of “hate” to Scheeben: “Ultramontane Scheeben certainly was. . . . However, Scheeben’s articles in defense of [Vatican I] were essentially occasional pieces, unrepresentative of the general tenor of his theological work.” Aidan Nichols, O.P., “Homage to Scheeben,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scribe of the Kingdom: Essays on Theology and Culture")]), _vm._v(", Volume I (London: Sheed & Ward, 1994): 205–13, here 205–6.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-021"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-021-backlink"
    }
  }, [_vm._v("60")]), _vm._v(". Pinckaers would seem to agree: “We do not find any trace in St. Thomas of the common modern presupposition according to which the intervention of faith and grace disrupts necessarily, as a foreign element, the activity of reason, liberty, and human nature” (Pinckaers, “Natural Desire,” 638).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-020"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-020-backlink"
    }
  }, [_vm._v("61")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", 337.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-019"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-019-backlink"
    }
  }, [_vm._v("62")]), _vm._v(". Nichols, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romance and System")]), _vm._v(", 289; all italics in the original text.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-018"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-018-backlink"
    }
  }, [_vm._v("63")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Glories of Divine Grace")]), _vm._v(", 74; emphases added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-017"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-017-backlink"
    }
  }, [_vm._v("64")]), _vm._v(". Matthias Joseph Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mysteries of Christianity")]), _vm._v(" (St. Louis: B. Herder Book Co., 1946), 385.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-016"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-016-backlink"
    }
  }, [_vm._v("65")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Glories of Divine Grace")]), _vm._v(", 100; emphases added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-015"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-015-backlink"
    }
  }, [_vm._v("66")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mysteries")]), _vm._v(", 384–85; emphases added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-014"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-014-backlink"
    }
  }, [_vm._v("67")]), _vm._v(". I am deliberately phrasing the correlation between rights and obligations in the way criticized by Mary Ann Glendon’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rights Talk: The Impoverishment of Political Discourse")]), _vm._v(" (New York: The Free Press, 1991), who scores this formulation for the way it expels the intermediate terms of virtue and responsibility: “The American rights dialect is distinguished not only by what we say and how we say it, but also by what we leave unsaid . . . [the] habitual silences concerning responsibilities” (76). The binary logic of rights vs. obligations also neglects any standard for adjudicating rights in conflict (like the right to a free press vs. the right to a fair trial). But this very situation highlights the oddity of Scheeben’s way of speaking of human rights "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vis-à-vis")]), _vm._v(" God and of God’s (therefore correlative) “obligations” toward humans. But he does so—as will become clear in the next few paragraphs—because of the way he radicalizes the kind of “adoption” we receive from God.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-013"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-013-backlink"
    }
  }, [_vm._v("68")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mysteries")]), _vm._v(", 377–78; emphases added. Here one is reminded of a line from de Lubac: “There can be no question of anything being due to the creature. But, one may perhaps say, it remains true none the less that once such a desire exists in the creature, it becomes the sign not merely of a possible gift from God, but of a certain gift.” Henri de Lubac, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mystery of the Supernatural")]), _vm._v(", 207.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-012"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-012-backlink"
    }
  }, [_vm._v("69")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mysteries")]), _vm._v(", 383; emphases added. Nor are these views to be found only in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mysteries")]), _vm._v(". In other writings, he shows himself equally comfortable with talk of “rights”: “As children of God, we have a far more intimate relation with God than adopted children have to their father. . . . We are his heirs and we have a right to this inheritance. This right is based on our birth.” Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Glories of Divine Grace")]), _vm._v(", 100–101.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-011"
    }
  }, [_c('p', {
    staticClass: "FN-T1"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-011-backlink"
    }
  }, [_vm._v("70")]), _vm._v(". Geniuses are like that: they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anticipate")]), _vm._v(". I am reminded here of what Harold Bloom said of Shakespeare: “[This is] Shakespeare’s most idiosyncratic strength: he is always ahead of you, conceptually and imagistically, whoever and whenever you are. He renders you anachronistic because he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("contains")]), _vm._v(" you; you cannot subsume him. You cannot illuminate him with a new doctrine, be it Marxism or Freudianism or Demanian linguistic skepticism. Instead, he will illuminate the doctrine, not by prefiguration but by postfiguration, as it were: all of Freud that matters most is there in Shakespeare already, with a persuasive critique of Freud besides. The Freudian map of the mind is Shakespeare’s; Freud seems only to have prosified it. Or, to vary my point, a Shakespearean reading of Freud illuminates and overwhelms the text of Freud; a Freudian reading of Shakespeare reduces Shakespeare, or would if we could bear a reduction that crosses the line into absurdities of loss. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Coriolanus")]), _vm._v(" is a far more powerful reading of Marx’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eighteenth Brumaire of Louis Napoleon")]), _vm._v(" than any Marxist reading of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Coriolanus")]), _vm._v(" could hope to be.” Harold Bloom, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Western Canon: The Books and School of the Ages")]), _vm._v(" (New York: Riverhead, 1994), 24.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-010"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-010-backlink"
    }
  }, [_vm._v("71")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", 275; emphasis added.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-009"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-009-backlink"
    }
  }, [_vm._v("72")]), _vm._v(". Scheeben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nature and Grace")]), _vm._v(", 343. In other words, Scheeben is trying to get away from Augustine’s notion of grace as mere "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("auxilium")]), _vm._v(" (aid for living the moral life) and more on the notion favored by the Eastern Fathers of grace as the agent of our "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apotheosis")]), _vm._v(", divinization.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-008"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-008-backlink"
    }
  }, [_vm._v("73")]), _vm._v(". As Paul says: “All who want to live piously in Christ Jesus will suffer persecution” (2 Tim. 3:12), which Balthasar glosses this way (adding along the way more Pauline support for the position of the discontinuitists: “To be baptized, then, means totally to renounce a life lived according to one’s own wishes, for ‘it is no longer I that live, but Christ lives in me’ (Gal. 2:20). Because ‘Christ did not please himself, we . . . ought not to please ourselves’ (Rom. 15:3, 1).” Balthasar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian State of Life")]), _vm._v(", 339. See also: “God is careful to make plainly visible not only the general unworthiness, but also the natural ineptitude of the one called. He chooses whom he will; if the one he has chosen accepts this mission, he becomes, as it were, a new creation called by the Lord out of nothingness” (ibid., 398).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-007"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-007-backlink"
    }
  }, [_vm._v("74")]), _vm._v(". Balthasar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian State of Life")]), _vm._v(", 27.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-006"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-006-backlink"
    }
  }, [_vm._v("75")]), _vm._v(". Feingold, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Desire")]), _vm._v(", 443. Also here: “The pastoral and spiritual solution to our crisis cannot lie in weakening the distinction between nature and grace, or [in] diminishing the coherence of the natural order, but only in rightly understanding how the Christian promise opens the horizon to what we already naturally desire in a dim and inefficacious way. Thus glory perfectly fulfills what nature would wish but dare not hope” (ibid., xxxvi).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-005"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-005-backlink"
    }
  }, [_vm._v("76")]), _vm._v(". When the aged senator from West Virginia, ninety-two-year-old Robert Byrd (known as the King of Pork for all the federal largesse he poured into his state), died in the summer of 2010, the Catholic (!) bishop of Charleston (the capital of West Virginia) chirruped that the Senator was surely now in heaven. One wonders if the burdened taxpayers from other states agreed, whose children will be saddled for generations to come with paying off the federal debt that was used to fund all that Appalachian bacon.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-004"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Oakes_A_Theology_of_Grace9#footnote-004-backlink"
    }
  }, [_vm._v("77")]), _vm._v(". Henri de Lubac, “The Church in Crisis,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology Digest,")]), _vm._v(" Vol. 17, No. 4 (Winter 1969): 312–25; here 319; henceforth cited as de Lubac, “Church in Crisis.” A revised version of this address was published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nouvelle Revue Théologique")]), _vm._v(" vol. 91 (1969): 580–96.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-978fcaf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Oakes_A_Theology_of_Grace9.vue
// module id = 81
// module chunks = 0